<template>
	<div class="margin_projet" :class="{ 'is-loading': scenario_loading }">

		<!-- ===== LOADER (chargement d'un scénario) : couvre uniquement la zone du studio, le menu reste visible ===== -->
		<div v-if="scenario_loading" class="studio-loading-overlay">
			<b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
			<div class="studio-loading-text">Chargement du scénario...</div>
		</div>

		<!-- ===== ONBOARDING ===== -->
		<div v-show="onboarding" :class="onboarding_screen === 'home' ? 'onboarding-wrapper' : 'onboarding-wrapper-plain'">

			<!-- Écran d'accueil -->
			<div v-if="onboarding_screen === 'home'" class="onboarding-home">
				<h2 class="onboarding-title">Éditeur de scénarios</h2>
				<div class="onboarding-actions">
					<div class="onboarding-card" @click="onboarding_screen = 'create'">
						<i class="fas fa-plus-circle onboarding-card-icon"></i>
						<div class="onboarding-card-label">Créer un nouveau scénario</div>
					</div>
					<div class="onboarding-card" @click="onboarding_open_load()">
						<i class="fas fa-folder-open onboarding-card-icon"></i>
						<div class="onboarding-card-label">Charger un scénario</div>
					</div>
				</div>
				<div class="onboarding-skip">
					<a href="#" @click.prevent="onboarding = false">Aller directement à l'éditeur</a>
				</div>
			</div>

			<!-- Écran création : nom du scénario -->
			<div v-else-if="onboarding_screen === 'create'" class="onboarding-create">
				<button class="onboarding-back" @click="onboarding_screen = 'home'">
					<i class="fas fa-arrow-left mr-1"></i> Retour
				</button>
				<h3 class="onboarding-subtitle">Nouveau scénario</h3>
				<div class="onboarding-field">
					<label>Nom du scénario</label>
					<b-form-input
						v-model="onboarding_name"
						placeholder="Mon scénario"
						:state="onboarding_name_error ? false : null"
						@input="onboarding_name_error = ''"
						autofocus />
					<b-form-invalid-feedback>{{ onboarding_name_error }}</b-form-invalid-feedback>
				</div>
				<div class="onboarding-field mt-3">
					<label>Mode d'édition</label>
					<div class="d-flex" style="gap:0.75rem; margin-top:0.5rem">
						<div
							class="onboarding-mode-card"
							:class="{active: onboarding_simple_mode === true}"
							@click="onboarding_simple_mode = true">
							<i class="fas fa-feather-alt mr-2"></i>
							<span class="font-weight-bold">Mode simple</span>
							<small class="d-block text-muted mt-1">Masque les options avancées</small>
						</div>
						<div
							class="onboarding-mode-card"
							:class="{active: onboarding_simple_mode === false}"
							@click="onboarding_simple_mode = false">
							<i class="fas fa-cogs mr-2"></i>
							<span class="font-weight-bold">Mode complet</span>
							<small class="d-block text-muted mt-1">Toutes les options disponibles</small>
						</div>
					</div>
				</div>
				<b-button variant="primary" class="mt-3" :disabled="onboarding_checking" @click="onboarding_check_name">
					<b-spinner small v-if="onboarding_checking" class="mr-1"></b-spinner>
					Suivant
				</b-button>
			</div>



			<!-- Écran chargement : liste des scénarios -->
			<div v-else-if="onboarding_screen === 'load'" class="onboarding-load">
				<button class="onboarding-back" @click="onboarding_screen = 'home'">
					<i class="fas fa-arrow-left mr-1"></i> Retour
				</button>
				<h3 class="onboarding-subtitle">Charger un scénario</h3>
				<b-form-input v-model="onboarding_load_search" placeholder="Rechercher..." class="mb-3" autofocus />
				<div v-if="onboarding_load_loading" class="text-muted py-3">
					<b-spinner small class="mr-2"></b-spinner> Chargement des scénarios...
				</div>
				<div v-else class="onboarding-load-list">
					<div v-if="onboarding_load_filtered.length === 0" class="text-muted py-2">Aucun scénario trouvé.</div>
					<div v-for="s in onboarding_load_filtered" :key="s.uid || s.value"
						 class="onboarding-load-item" @click="onboarding_load_scenario(s)">
						<i class="fas fa-file-code onboarding-load-item-icon"></i>
						<div class="onboarding-load-item-content">
							<div class="onboarding-load-item-name">{{ s.text }}</div>
							<div v-if="s.description" class="onboarding-load-item-desc">{{ s.description }}</div>
						</div>
						<i class="fas fa-chevron-right onboarding-load-item-arrow"></i>
					</div>
					<!-- Archivés -->
					<div class="mt-3" style="border-top: 1px solid #e0e0e0; padding-top: 0.5rem;">
						<a href="#" class="text-muted" style="font-size:0.82em;" @click.prevent="onboarding_show_archived = !onboarding_show_archived">
							<i :class="(onboarding_show_archived || (onboarding_load_search && onboarding_archived_filtered.length > 0)) ? 'fas fa-chevron-down' : 'fas fa-chevron-right'" class="mr-1" style="font-size:0.75em;"></i>
							Scénarios archivés
							<span v-if="onboarding_load_search">({{ onboarding_archived_filtered.length }} / {{ list_projects_archive.length }})</span>
							<span v-else>({{ list_projects_archive.length }})</span>
						</a>
						<div v-if="onboarding_show_archived || (onboarding_load_search && onboarding_archived_filtered.length > 0)" class="mt-2">
							<div v-if="onboarding_archived_filtered.length === 0" class="text-muted py-1" style="font-size:0.85em;">Aucun scénario archivé trouvé.</div>
							<div v-for="s in onboarding_archived_filtered" :key="s.uid || s.value"
								 class="onboarding-load-item" style="opacity:0.75;" @click="onboarding_load_scenario(s)">
								<i class="fas fa-archive onboarding-load-item-icon" style="color:#999;"></i>
								<div class="onboarding-load-item-content">
									<div class="onboarding-load-item-name">
										{{ s.text }}
										<b-badge variant="secondary" class="ml-1" style="font-size:0.7em; vertical-align:middle;">Archivé</b-badge>
									</div>
									<div v-if="s.description" class="onboarding-load-item-desc">{{ s.description }}</div>
								</div>
								<i class="fas fa-chevron-right onboarding-load-item-arrow"></i>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
		<!-- Modale confirmation Nouveau -->
		<b-modal id="modal-nouveau" title="Nouveau scénario" hide-footer>
			<p>Avez-vous bien enregistré le scénario en cours ?</p>
			<div class="d-flex gap-2 justify-content-end">
				<b-button variant="outline-secondary" @click="$bvModal.hide('modal-nouveau')">Retour</b-button>
				<b-button variant="primary" @click="nouveauScenarioConfirm">Continuer</b-button>
			</div>
		</b-modal>

		<!-- Modale confirmation Mode complet -->
		<b-modal :id="'modal-mode-complet-' + id" title="Passer en mode complet" hide-footer>
			<p>Le mode complet débloque toutes les options avancées de l'éditeur : tags, paramètres de traitement, types de données avancés, traitements suivants…</p>
			<p><strong>Attention : ce changement est irréversible.</strong> Une fois en mode complet, il n'est plus possible de revenir en mode simple.</p>
			<div class="d-flex justify-content-end" style="gap:0.5rem">
				<b-button variant="outline-secondary" @click="$bvModal.hide('modal-mode-complet-' + id)">Annuler</b-button>
				<b-button variant="primary" @click="activateComplexMode">Passer en mode complet</b-button>
			</div>
		</b-modal>

		<!-- ===== FIN ONBOARDING ===== -->

		<div v-show="!onboarding">
		<div>
			<a
				v-if="config"
				class="info"
				v-show="state == 'configuration' && panel_section != 'donnees'"
				href="https://docs.smartmydata.com/editeur_de_scenarios/accueil-configuration.html"
				target="_blank"
				><i class="fas fa-info-circle"></i></a
			>
			<a
				v-if="config"
				class="info"
				v-show="state == 'configuration' && panel_section == 'donnees' && !onboarding_data_mode"
				href="https://docs.smartmydata.com/editeur_de_scenarios/data.html"
				target="_blank"
				><i class="fas fa-info-circle"></i
			></a>

			<a
				v-if="config"
				v-show="state == 'etape'"
				href="https://docs.smartmydata.com/editeur_de_scenarios/scenario.html"
				target="_blank"
				><i class="fas fa-info-circle"></i
			></a>
		</div>
		<div>
			<notifications position="top center" group="info" />

<div v-show="state == 'configuration' && !onboarding_data_mode">
					<h6 v-if="config || config_name">
						Scenario {{ name }}
						<b-badge v-if="current_scenario_archived" variant="warning" class="ml-1" style="font-size:0.7em; vertical-align:middle;" title="Ce scénario est archivé"><i class="fas fa-archive mr-1"></i>Archivé</b-badge>
					</h6>

					<div class="toolbar-btns">
					<b-button
						class="bouton"
						:variant="state == 'configuration' && panel_section != 'donnees' ? 'primary' : 'secondary'"
						title="Configuration"
						@click="set_state('configuration')"
						><i class="fas fa-cogs"></i></b-button>
				<b-button
					class="bouton"
					:variant="panel_section == 'donnees' ? 'primary' : 'secondary'"
					title="Données initiales"
					@click="set_state('données')"
					><i class="fas fa-table"></i></b-button>
				<b-button
					class="bouton"
					:variant="state == 'etape' ? 'primary' : 'secondary'"
					title="Étapes"
					@click="set_state('etape')"
					><i class="fas fa-list"></i></b-button>
				<b-button
					v-if="config && name && version"
					class="bouton"
					variant="secondary"
					title="Sauvegarder"
					@click="save_db(false, false)"
					><i class="fas fa-save"></i></b-button>
				<b-button
					class="bouton"
					variant="secondary"
					title="Nouveau scénario"
					@click="nouveau_scenario"
					><i class="fas fa-plus"></i></b-button>
				</div>

			</div>

			<div v-show="state == 'configuration'">
				<!-- Onboarding data mode banner -->
				<div v-if="onboarding_data_mode" class="onboarding-data-mode-wrapper">
					<button class="onboarding-back" @click="onboarding_data_mode = false; onboarding = true; onboarding_screen = 'create'">
						<i class="fas fa-arrow-left mr-1"></i> Retour
					</button>
					<div class="onboarding-data-banner">
						<h3 class="onboarding-subtitle mb-0">Données initiales</h3>
						<b-button variant="primary" class="ml-auto" @click="onboarding_confirm">
							<i class="fas fa-arrow-right mr-1"></i> Créer et choisir la première étape
						</b-button>
					</div>
				</div>
				<!-- Layout: nav gauche + contenu -->
				<div class="scenario-grid" :class="{'onboarding-mode': onboarding_data_mode || panel_section == 'donnees'}">
					<nav v-show="!onboarding_data_mode && panel_section != 'donnees'" class="scenario-nav">
						<button class="scenario-nav-item" :class="{active: panel_section=='scenario'}" @click="scrollToSection('scenario')"><i class="fas fa-sliders-h mr-2"></i>Scénario</button>
						<button class="scenario-nav-item" :class="{active: panel_section=='colonnes'}" @click="scrollToSection('colonnes')"><i class="fas fa-columns mr-2"></i>Colonnes</button>
						<button v-if="listWords.length > 0" class="scenario-nav-item" :class="{active: panel_section=='listes'}" @click="scrollToSection('listes')"><i class="fas fa-list-ul mr-2"></i>Listes</button>
						<button v-if="config" class="scenario-nav-item" :class="{active: panel_section=='donnees_traitement'}" @click="scrollToSection('donnees_traitement')"><i class="fas fa-database mr-2"></i>Données de traitement</button>
						<button v-if="config && !simple_mode" class="scenario-nav-item" :class="{active: panel_section=='params'}" @click="scrollToSection('params')"><i class="fas fa-cog mr-2"></i>Paramètres de traitement</button>
						<button v-if="!simple_mode" class="scenario-nav-item" :class="{active: panel_section=='tags'}" @click="scrollToSection('tags')"><i class="fas fa-tags mr-2"></i>Tags</button>
					</nav>
					<div class="scenario-sections">
					<!-- Modal Charger -->
					<b-modal v-if="config" :id="'modal-charger-' + id" title="Charger un scénario" :hide-footer="true">
						<span>Nom</span>
						<v-select
							v-model="load_name"
							:options="modal_load_show_archived ? list_projects_archive.map(p => ({ text: p.libelle, value: p.libelle })) : list_name"
							label="text"
							:reduce="(option) => option.value"></v-select>
						<div class="mt-1 mb-2">
							<a href="#" class="text-muted" style="font-size:0.82em;" @click.prevent="modal_load_show_archived = !modal_load_show_archived; load_name = ''">
								<i :class="modal_load_show_archived ? 'fas fa-toggle-on' : 'fas fa-toggle-off'" class="mr-1"></i>
								{{ modal_load_show_archived ? 'Voir les actifs' : 'Voir les archivés (' + list_projects_archive.length + ')' }}
							</a>
						</div>
						<span>Version</span>
						<v-select
							label="text"
							:reduce="(option) => option.value"
							v-model="load_version"
							:options="list_version"></v-select>
						<br /><br />
						<b-button v-on:click="load_db()">Charger</b-button>
						<br /><br />
						<b-form-file
							accept=".json"
							@change="load_file"
							placeholder="charger depuis un fichier"></b-form-file>
						<br /><br />
						<b-button v-b-toggle="'list' + id">Liste des scénarios</b-button>&nbsp;
						<b-button @click="zip">Zip des scénarios</b-button>
						<b-collapse :id="'list' + id">
							<div v-for="(scenario, idx) in list_name" :key="idx">
								<p><router-link
									:to="{ name: 'project_v1', params: { id: scenario.uid } }"
									>{{scenario.text}}</router-link><br />
								<span style="white-space: pre-wrap;" v-if="scenario.description">{{scenario.description}}</span></p>
							</div>
						</b-collapse>
					</b-modal><!-- fin modal Charger -->

					<!-- Section Scénario -->
					<div id="section-scenario" class="scenario-section" v-show="panel_section != 'donnees' && !onboarding_data_mode">
						<h3 class="section-title">Scénario</h3>
						<!-- Boutons d'action -->
						<div v-if="config" class="scenario-actions-bar mb-3">
							<b-button v-b-modal="'modal-charger-' + id" variant="outline-secondary" size="sm"><i class="fas fa-folder-open mr-1"></i> Charger</b-button>
							<b-button v-b-modal="'modal-sauvegarder-' + id" variant="outline-secondary" size="sm"><i class="fas fa-save mr-1"></i> Sauvegarder</b-button>
							<b-button v-b-modal="'modal-renommer-' + id" variant="outline-secondary" size="sm"><i class="fas fa-i-cursor mr-1"></i> Renommer</b-button>
							<b-button v-b-modal="'modal-archiver-' + id" variant="outline-secondary" size="sm"><i class="fas fa-archive mr-1"></i> Archiver</b-button>
						</div>
						<div v-if="config">
							<span>Nom</span>
							<b-form-input v-model="name"></b-form-input>
							<span>Version</span>
							<b-form-input
								v-on:update="update_version"
								v-model="version"></b-form-input>
							<span>Description du projet</span>
							<b-textarea
								v-model="description_project"
								rows="5"></b-textarea>
							<div v-if="_canGenerateIa" class="d-flex align-items-center mt-1">
							<b-button 
								@click="generate_project_description" 
								:disabled="generating_project_description || !name"
								variant="link" class="p-0">
								<i class="fas fa-robot"></i> Générer la description du projet
							</b-button>
							<b-button variant="link" class="p-0 ml-3 text-muted" @click="toggle_custom_prompt_project">
								<i class="fas fa-sliders-h"></i>
								{{ show_custom_prompt_project ? 'Masquer le prompt' : 'Personnaliser le prompt' }}
							</b-button>
							<b-button v-if="custom_prompt_project" variant="link" class="p-0 ml-2 text-danger" title="Réinitialiser le prompt" @click="reset_custom_prompt_project">
								<i class="fas fa-undo"></i>
							</b-button>
						</div>
						<b-collapse v-if="_canGenerateIa" v-model="show_custom_prompt_project">
							<div class="mt-2 p-2 border rounded bg-light">
								<small class="text-muted d-block mb-1">Début du prompt envoyé à l'IA — les données du scénario sont toujours ajoutées à la suite.</small>
								<b-textarea v-model="custom_prompt_project" rows="10" />
							</div>
						</b-collapse>
						<div v-if="generating_project_description" class="mt-2">
							<b-spinner small></b-spinner>
							<small class="ml-2">Génération en cours...</small>
						</div>
							<b-button v-b-modal="'modal-descriptions' + id" variant="link" class="mt-2">
								<i class="fas fa-edit"></i> Description courte et commentaire
							</b-button>
							<b-modal
								:id="'modal-descriptions' + id"
								title="Description courte et commentaire"
								size="lg"
								hide-footer>
								<span>Description courte du projet</span>
								<b-textarea
									v-model="short_description_project"
									rows="5"></b-textarea>
								<br />
								<span>Commentaire du projet</span>
								<b-textarea
									v-model="comment_project"
									rows="5"></b-textarea>
							</b-modal>
							<br />
							<span>Description de la version</span>
							<b-textarea
								v-model="description"
								rows="5"></b-textarea>
							<div v-if="list_version">
								<br />
								<b-button v-b-toggle="'list-version' + id">Historique des versions</b-button>
								<b-collapse :id="'list-version' + id">
									<div v-for="(version, idx) in list_version" :key="idx">
										<p><u>{{version.text}}</u><br />
										<span style="white-space: pre-wrap;">{{version.description}}</span>
										</p>
									</div>
								</b-collapse>
							</div>
							<p v-if="prod_version">
								Version active pour les traitements :
								{{ prod_version }}
							</p>
							<br />
							<b-button 
								v-b-modal="'modal-all-steps-descriptions'"
								:disabled="steps.length === 0"
								variant="link">
								<i class="fas fa-list-ul"></i> Voir toutes les descriptions
							</b-button>
							<b-button 
								@click="generate_all_descriptions" 
								:disabled="generating_descriptions || steps.length === 0"
								variant="link">
								<i class="fas fa-robot"></i> Générer toutes les descriptions des étapes
							</b-button>
							<b-form-checkbox 
								v-model="generate_only_empty_descriptions"
								class="ml-2 d-inline-block">
								Uniquement les étapes vides
							</b-form-checkbox>

						<div v-if="generating_descriptions" class="mt-2">
							<b-progress :value="description_progress" :max="steps.length" animated>
								<b-progress-bar :value="description_progress" :max="steps.length">
									{{ Math.round((description_progress / steps.length) * 100) }}%
								</b-progress-bar>
							</b-progress>
							<small>Génération en cours : étape {{ description_current }} sur {{ steps.length }}</small>
						</div>

						<b-modal
							:id="'modal-all-steps-descriptions'"
							title="Descriptions et commentaires des étapes"
							size="xl"
							hide-footer>
							<div v-if="steps.length === 0" class="text-center text-muted">
								Aucune étape dans le scénario
							</div>
							<div v-else>
								<div v-for="(step, idx) in steps" :key="step.id" class="mb-4 pb-3 border-bottom">
									<h5>
										<span class="badge badge-primary mr-2">{{ idx + 1 }}</span>
										{{ get_step_info(step.id).description || get_step_info(step.id).action_label || step.data.action || 'Action non définie' }}
									</h5>
									<div v-if="get_step_info(step.id).comment" class="mb-2">
										<strong><i class="fas fa-comment"></i> Commentaire :</strong>
										<p class="ml-3 mb-0" style="white-space: pre-wrap;">{{ get_step_info(step.id).comment }}</p>
									</div>
									<div v-if="get_step_info(step.id).long_description" class="mb-2">
										<strong><i class="fas fa-align-left"></i> Description :</strong>
										<p class="ml-3 mb-0" style="white-space: pre-wrap;">{{ get_step_info(step.id).long_description }}</p>
									</div>
									<div v-if="!get_step_info(step.id).comment && !get_step_info(step.id).long_description" class="text-muted ml-3">
										<em>Aucune description ou commentaire</em>
									</div>
								</div>
							</div>
						</b-modal>

							<hr />

							<div class="flex align-items-center" v-if="!user.env">
								<div
									class="mr-2"
									:class="version_prod ? 'opacity-25' : ''">
									Test
								</div>
								<b-form-checkbox
									switch
									v-model="version_prod"
									:disabled="prod_version ? false : true">
								</b-form-checkbox>
								<div :class="!version_prod ? 'opacity-25' : ''">
									Actif
								</div>
								<b-button variant="link" class="ml-3 p-0" v-b-modal="'modal-project-env'">Autres environnements</b-button>
							</div>
							<div class="flex align-items-center" v-if="user.env">
								<div
									class="mr-2"
									:class="version_env ? 'opacity-25' : ''">
									Test
								</div>
								<b-form-checkbox
									switch
									v-model="version_env"
									:disabled="prod_version ? false : true">
								</b-form-checkbox>
								<div :class="!version_env ? 'opacity-25' : ''">
									Actif
								</div>
								<b-button variant="link" class="ml-3 p-0" v-b-modal="'modal-project-env'">Autres environnements</b-button>
							</div>

							<p v-if="!prod_version">
								Ne peut être mis en test car actif
							</p>

							<div class="d-flex align-items-center mb-1" style="gap:0.5rem">
								<span>Traitement par lots</span>
								<b-button variant="link" style="padding:1px" v-b-tooltip.hover title="Découpe le fichier d'entrée en petits lots de N lignes traités les uns à la suite des autres. Évite les erreurs serveur sur les grands volumes de données."><i class="fas fa-info-circle"></i></b-button>
								<b-select v-model="lines_mode" style="width:auto" :options="[
									{value: false, text: 'Désactivé'},
									{value: true, text: 'Activé'},
									{value: 'steps', text: 'Certaines étapes'},
								]" />
								<span v-if="lines_mode">Lignes / lot</span>
								<b-input v-if="lines_mode" type="number" :min="1" step="1" v-model="lines_nb" style="width:80px"></b-input>
							</div>

							<div style="display:grid; grid-template-columns: 1fr 1fr; gap:0.25rem 1rem">
							<b-form-checkbox v-if="!simple_mode" v-model="inDropdownTraitements">Apparaît dans la liste de création de traitements</b-form-checkbox>
							<b-form-checkbox v-model="render_files">Visualisation automatique des fichiers</b-form-checkbox>
							<b-form-checkbox v-if="!simple_mode" v-model="inDropdownPostTreatments">Apparaît dans la liste des pré/post traitements des documents</b-form-checkbox>
							<b-form-checkbox v-model="browser">Si possible, test avec le navigateur</b-form-checkbox>
							<b-form-checkbox v-if="!simple_mode" v-model="sub_treatment">
									Suivi individuel des lots enfants
									<b-button variant="link" style="padding:1px" v-b-tooltip.hover title="Lorsqu'un traitement génère des lots enfants, l'interface suit chaque enfant individuellement sans attendre que le parent soit terminé."><i class="fas fa-info-circle"></i></b-button>
								</b-form-checkbox>
							</div>

							<b-modal
								:hide-footer="true"
								:id="'modal-project-env'"
								title="Autres environnements à mettre en actif">
								<b-input-group>
									<b-form-checkbox-group
										id="boxes"
										v-model="sync_env"
										:options="env_list"
										name="boxes"
										stacked />
								</b-input-group>
							</b-modal>

							<div v-if="!simple_mode" class="mt-2">
								<span>Traitements suivants</span>
								<b-select :options="projects_options" v-model="next_treatments" multiple :select-size="10"></b-select>
							</div>

							<div v-if="simple_mode" class="mt-3">
								<b-button variant="outline-secondary" size="sm" v-b-modal="'modal-mode-complet-' + id">
									<i class="fas fa-expand-alt mr-1"></i> Passer en mode complet
								</b-button>
							</div>
						</div>
						<div v-else>
							<span>Nom : {{ name }}</span>
							<br />
							<span>Version : {{ version }}</span>
						</div>

					</div><!-- fin section Scénario -->

					<!-- Section Données initiales -->
					<div id="section-donnees" class="scenario-section" v-show="panel_section == 'donnees' || onboarding_data_mode">
						<h3 v-if="!onboarding_data_mode">Données initiales</h3>
						<b-form-select
							v-model="initial_method"
							:options="filtered_initial_method_options"
							class="mb-2">
						</b-form-select>
						<div v-if="initial_method === 'Airtable'">
							<InitDataAirtable ref="start_tabulator"></InitDataAirtable>
						</div>
						<div v-if="initial_method === 'Google sheets'">
							<InitDataGsheets ref="start_tabulator"></InitDataGsheets>
						</div>
						<div v-if="initial_method == 'fichier'">
							<div v-if="project_data.column_import">
								<b-button v-on:click="setColumnImport()">Colonnes du projet</b-button>
								<br /><br />
							</div>
							<edit_tabulator
								:select_mode="true"
								:columns_type="tabulator_columns_type"
								:selectable="true"
								@update="importFile"
								@filename_changed="name_file_init = $event"
								ref="start_tabulator"></edit_tabulator>
						</div>
						<div v-if="initial_method == 'base de données'">
							<b-form-select v-model="table" :options="tables" v-on:input="updateTable" />
							<database v-show="table" :name="false" :edit="false" :filename="name_file_init" @update="importFile" ref="start_tabulator"></database>
							<div class="d-flex align-items-center mt-2" style="gap:8px">
								<small class="text-muted text-nowrap"><i class="fas fa-file-csv mr-1"></i>Nom du fichier :</small>
								<b-form-input size="sm" v-model="name_file_init" style="max-width:220px" placeholder="data.csv" />
							</div>
							<br />
						</div>
						<div v-if="initial_method == 'base de données multibases'">
							<DatabaseRequestView :minimal="true" ref="start_tabulator" />
							<br />
						</div>
						<div v-if="initial_method == 'ensemble'">
							<ensemble :name="false" @update="importFile" ref="start_tabulator"></ensemble>
						</div>
						<div v-if="initial_method == 'fichiers'">
							<files-upload :name="false" :upload="false" @update="importFile" ref="start_tabulator"></files-upload>
						</div>
						<div v-if="initial_method == 'documents'">
							<documents :select="true" @update="importFile" ref="start_tabulator"
								:id_prefix="(init_data && init_data['documents'] && init_data['documents'].hasOwnProperty('id_prefix')) ? init_data['documents'].id_prefix : false"></documents>
						</div>
						<div v-if="initial_method == 'fichiers - url'">
							<files-upload :name="false" :upload="true" @update="importFile" ref="start_tabulator" />
						</div>
					</div><!-- fin section Données initiales -->

					<!-- Modal Sauvegarder -->
					<b-modal v-if="config" :id="'modal-sauvegarder-' + id" title="Sauvegarder" :hide-footer="true">
						<span>Nom</span>
						<b-form-input v-model="name"></b-form-input>
						<span>Version</span>
						<b-form-input v-model="next_version"></b-form-input>
						<b-button class="mt-3" v-on:click="save_db()"
							>Enregistrer</b-button
						>
						<br /><br />
						<b-button v-on:click="save()"
							>Enregistrer dans un fichier</b-button
						><br /><br />
						<div v-if="save_exist">
							Ce scénario avec cette version existe déjà, cette
							sauvegarde va la remplacer
							<b-button
								variant="danger"
								v-on:click="save_db(false)"
								>Confirmer</b-button
							>
						</div>
					</b-modal><!-- fin modal Sauvegarder -->

					<!-- <b-tab v-show="config" title="Projet">
            <p>Sélectionnner un projet</p>
            <b-form-select
              @change="setProject()"
              v-model="project"
              :options="projects_options"
              :value="project"
            />
          </b-tab> -->

			<!-- (Tests supprimé)
						<b-container
							style="margin: 0; padding: 0; max-width: none">
							<b-row
								ref="div_row_test"
								style="margin: 0; padding: 0; max-width: none">
								<b-col
									ref="div_menu_test"
									md="auto"
									style="
										margin: 0;
										padding: 0;
										max-width: none;
									">
									<b-button
										class="bouton"
										variant="link"
										@click="set_state_test('configuration')"
										>Configuration</b-button
									>
									<div>
										Tests
										<b-button
											class="bouton"
											variant="link"
											@click="add_test()"
											>+</b-button
										>
									</div>
									<div
										v-for="test in tests.tests"
										:key="test.uid">
										<b-button
											:style="
												'color: ' +
												(test.color
													? test.color
													: 'black')
											"
											class="bouton"
											variant="link"
											@click="set_state_test(test.uid)"
											>{{ test.name }}</b-button
										>
									</div>
								</b-col>
								<b-col
									:style="
										'max-width: ' + (size_test - 100) + 'px'
									">
									<div v-show="state_test == 'configuration'">
										<div>Configuration</div>
										<br />
										<div
											v-for="(element, idx) in steps"
											:key="element.id">
											<span>
												<b-form-checkbox
													v-model="element.test"
													:value="true"
													:unchecked-value="false">
													{{ idx + 1 }} -
													{{
														element.description !=
														undefined
															? element.description
																	.substring(
																		0,
																		element.description.indexOf(
																			"."
																		)
																	)
																	.substring(
																		0,
																		30
																	) ||
															  element.description.substring(
																	0,
																	30
															  ) ||
															  element.data
																	.label ||
															  "nouvelle étape"
															: "nouvelle étape"
													}}{{
														element.description
															? element
																	.description
																	.length > 30
																? "..."
																: ""
															: ""
													}}
												</b-form-checkbox>
											</span>
										</div>
										<br />
										<div>
											<b-form-checkbox
												v-model="
													tests.configuration.end
												"
												:value="true"
												:unchecked-value="false"
												>Fichier final</b-form-checkbox
											>
										</div>
									</div>
									<div
										v-for="(test, idx) in tests.tests"
										:key="test.uid">
										<div v-show="state_test == test.uid">
											<b-input
												v-model="test.name"></b-input>
											<br />
											<b-button @click="set_test(idx)"
												><i
													class="fas fa-camera"></i></b-button
											>&nbsp;
											<b-button @click="start_test(idx)"
												><i class="fas fa-play"></i
											></b-button>
											<br /><br />
											<p>Données initiales</p>
											<edit_tabulator
												:columns_type="tabulator_columns_type"
												:extern_file="false"
												:ref="
													'tabulator' + idx
												"></edit_tabulator>
											<br />
											<div
												v-for="step in test.steps"
												:key="step.uid">
												<div>
													<b
														>{{
															step.step
																.description !=
															undefined
																? step.step.description
																		.substring(
																			0,
																			step.step.description.indexOf(
																				"."
																			)
																		)
																		.substring(
																			0,
																			30
																		) ||
																  step.step.description.substring(
																		0,
																		30
																  ) ||
																  step.step.data
																		.label ||
																  "nouvelle étape"
																: "nouvelle étape"
														}}{{
															step.step
																.description
																? step.step
																		.description
																		.length >
																  30
																	? "..."
																	: ""
																: ""
														}}</b
													>
												</div>
												<p>Test</p>
												<edit_tabulator
													:columns_type="tabulator_columns_type"
													:extern_file="false"
													:ref="
														'tabulator' +
														idx +
														step.step.data.uid
													"></edit_tabulator>
												<p>Résultat</p>
												<edit_tabulator
													:columns_type="tabulator_columns_type"
													:extern_file="false"
													:ref="
														'tabulator' +
														idx +
														step.step.data.uid +
														'result'
													"></edit_tabulator>
												<div v-show="step.diff">
													<div
														v-if="
															step.diff &&
															step.diff
																.nb_lines != 0
														">
														Nombres de lignes en
														{{
															step.diff.nb_lines >
															0
																? "moins"
																: "plus"
														}}
														:
														{{
															step.diff.nb_lines >
															0
																? step.diff
																		.nb_lines
																: -step.diff
																		.nb_lines
														}}
													</div>
													<div
														v-if="
															step.diff &&
															step.diff
																.columns_less &&
															step.diff
																.columns_less
																.length > 0
														">
														Colonnes en moins :
														{{
															step.diff.columns_less.join(
																", "
															)
														}}
													</div>
													<div
														v-if="
															step.diff &&
															step.diff
																.columns_more &&
															step.diff
																.columns_more
																.length > 0
														">
														Colonnes en plus :
														{{
															step.diff.columns_more.join(
																", "
															)
														}}
													</div>
													<div
														v-show="
															step.diff &&
															step.diff.data &&
															step.diff.data
																.length > 0
														">
														Différences
													</div>
													<edit_tabulator
														:columns_type="tabulator_columns_type"
														v-show="
															step.diff &&
															step.diff.data &&
															step.diff.data
																.length > 0
														"
														:extern_file="false"
														:ref="
															'tabulator' +
															idx +
															step.step.data.uid +
															'diff'
														"></edit_tabulator>
													<br />
												</div>
											</div>
											<i
												class="fa fa-times close"
												@click="removeTestAt(idx)"></i>
										</div>
									</div>
						</b-col>
						</b-row>
						</b-container>
					<!-- fin Tests supprimé) -->


					<!-- Modal Renommer -->
					<b-modal v-if="config" :id="'modal-renommer-' + id" title="Renommer" :hide-footer="true">
						<p>Nom actuel : {{ name }}</p>
						<span>Nouveau nom</span>
						<b-form-input v-model="new_name"></b-form-input>
						<br />
						<b-button v-on:click="rename()">Renommer</b-button>
					</b-modal><!-- fin modal Renommer -->

					<!-- Modal Archiver -->
					<b-modal v-if="config" :id="'modal-archiver-' + id" title="Archiver" :hide-footer="true" size="xl">
<div class="mt-2 mb-3 d-flex align-items-center" style="gap: 0.75rem;">
					<b-button-group size="sm">
						<b-button
							:variant="archive_filter === 'all' ? 'primary' : 'outline-secondary'"
							@click="archive_filter = 'all'"
						>Tous ({{ list_projects.length + list_projects_archive.length }})</b-button>
						<b-button
							:variant="archive_filter === 'active' ? 'success' : 'outline-secondary'"
							@click="archive_filter = 'active'"
						>Actifs ({{ list_projects.length }})</b-button>
						<b-button
							:variant="archive_filter === 'archived' ? 'secondary' : 'outline-secondary'"
							@click="archive_filter = 'archived'"
						>Archivés ({{ list_projects_archive.length }})</b-button>
					</b-button-group>
					<b-button
						size="sm"
						variant="outline-info"
						:disabled="archive_loading_treatments"
						@click="loadLastTreatments"
					>
						<b-spinner v-if="archive_loading_treatments" small class="mr-1"></b-spinner>
						<i v-else class="fas fa-history mr-1"></i>
						Dernier traitement
					</b-button>
					</div>

					<b-table
						:items="projects_filtered_for_archive"
						:fields="archive_table_fields"
						striped hover responsive small
						sort-icon-left
					>
<template #cell(last_treatment)="row">
						<span v-if="archive_last_treatments[row.item.uid] === undefined" class="text-muted">—</span>
						<span v-else-if="archive_last_treatments[row.item.uid] === null" class="text-muted"><em>aucun</em></span>
						<span v-else>{{ archive_last_treatments[row.item.uid] }}</span>
					</template>

					<template #cell(test_date)="row">
						<span v-if="row.item.test_date">{{ row.item.test_date }}</span>
						<span v-else class="text-muted"><em>jamais testé</em></span>
					</template>

					<template #cell(archive)="row">
							<b-badge :variant="row.item.archive ? 'secondary' : 'success'">
								{{ row.item.archive ? 'Archivé' : 'Actif' }}
							</b-badge>
						</template>

						<template #cell(actions)="row">
							<b-button
								v-if="!row.item.archive"
								size="sm"
								variant="outline-warning"
								@click="archiveProject(row.item)"
							>
								<i class="fas fa-archive"></i> Archiver
							</b-button>
							<b-button
								v-else
								size="sm"
								variant="outline-success"
								@click="unarchiveProject(row.item)"
							>
								<i class="fas fa-box-open"></i> Désarchiver
							</b-button>
						</template>
					</b-table>
				</b-modal><!-- fin modal Archiver -->

				<!-- === Sections données (dans le panneau unifié) === -->
				<div id="section-colonnes" class="scenario-section" v-show="panel_section != 'donnees' && !onboarding_data_mode">
						<h3 class="section-title">Colonnes <b-button variant="link" style="padding:1px" v-b-tooltip.hover title="Définit les colonnes disponibles dans les conditions des étapes"><i class="fas fa-info-circle"></i></b-button></h3>
						<div ref="tabulator_columns" class="table-striped"></div>
						<b-button v-on:click="addLine()"
							><i class="fas fa-plus-circle"></i> ligne</b-button
						>
						<template v-if="!simple_mode">
							<h3 class="subsection-title">Colonnes - types avancés <b-button variant="link" style="padding:1px" v-b-tooltip.hover title="Contrôle l'affichage dans les tableaux de résultats (image, vidéo, html…)"><i class="fas fa-info-circle"></i></b-button></h3>

							<b-card v-for="(data, key) in tabulator_columns_type" :key="key">
								<p>Colonne : {{key}}</p>
								<p>Type
									<b-select v-model="data.type" :options='["", "image", "video", "html"]'></b-select>
								</p>
								<p>Blacklists and whitelist
									<b-checkbox v-model="data.black_white_lists" />
								</p>
								<b-button variant="link" @click="delete tabulator_columns_type[key]"><i class="fas fa-trash"></i></b-button>
							</b-card>
							<p>Nouvelle colonne
								<b-input v-model="tabulator_columns_type_new"></b-input>
							</p>
							<b-button
								@click="tabulator_columns_type[tabulator_columns_type_new] = {type: ''}; tabulator_columns_type_new = ''"
								variant="primary">
								<i class="fas fa-plus"></i>
							</b-button>

							<h3 class="subsection-title">Colonnes de résultats <b-button variant="link" style="padding:1px" v-b-tooltip.hover title="Définit les colonnes affichées dans la vue de validation/relecture des résultats de traitement"><i class="fas fa-info-circle"></i></b-button></h3>

							<array_editor ref="columns_result" :start_data="columns_result" @update="update_columns_result"
								:columns='[
									{name: "name", libelle: "Nom", type: "text"},
									{name: "type", libelle: "Type", type: "list", options: ["text", "textarea", "json"]},
									{name: "only_if_no_empty", libelle: "Afficher seulement si non vide", type: "checkbox"},
									{name: "picking", libelle: "Picking", type: "checkbox"},
								]'
							/>
						</template>

				</div><!-- fin section Colonnes -->

					<!-- Section Listes -->
					<div id="section-listes" class="scenario-section" v-show="listWords.length > 0 && panel_section != 'donnees' && !onboarding_data_mode">
						<h3 class="section-title">Listes</h3>
						<b-tabs v-model="tabListIndex" content-class="mt-3">
							<b-tab
								:title="element.name"
								v-for="(element, idx) in listWords"
								:key="element.id">
								<listWords
									@update="updateList"
									:ref="element.id"
									:id="element.id"
									:db_mode="true"></listWords>
								<b-button
									size="sm"
									variant="danger"
									class="float-right"
									@click="removeListAt(idx)">
									Supprimer liste
								</b-button>
							</b-tab>
							<template #tabs-end>
								<b-nav-item
									role="presentation"
									@click.prevent="addList"
									href="#"
									><b>+</b></b-nav-item
								>
							</template>
						</b-tabs>
				</div><!-- fin section Listes -->
					
					<!-- Section Données initiales de traitement -->
					<div id="section-donnees_traitement" class="scenario-section" v-show="panel_section != 'donnees' && !onboarding_data_mode">
						<h3 class="section-title">Données de traitement <b-button variant="link" style="padding:1px" v-b-tooltip.hover title="Définit les types d'entrée proposés à l'utilisateur lors de la création d'un traitement (fichier, base de données, ensemble…)"><i class="fas fa-info-circle"></i></b-button></h3>

						<!-- Fichiers -->
						<div class="mb-2 border rounded p-2">
							<div class="d-flex align-items-center" style="gap:0.75rem">
								<b-form-checkbox v-model="init_data.fichiers.active">Fichiers</b-form-checkbox>
								<b-form-radio v-if="init_data.fichiers.active" v-model="init_data_default" value="fichiers" @change="onInitDataDefaultChange">Par défaut</b-form-radio>
							</div>
							<div v-if="init_data.fichiers.active" class="mt-2 ml-3">
								<div class="d-flex align-items-center mb-1" style="gap:0.5rem">
									<label class="mb-0" style="white-space:nowrap">Format accepté (ex: .csv,.txt)</label>
									<b-input v-model="init_data.fichiers.type" size="sm" placeholder=".csv,.txt" style="max-width:200px"></b-input>
								</div>
								<b-form-checkbox v-model="init_data.fichiers.at_least_one_file">Au moins 1 fichier requis</b-form-checkbox>
							</div>
						</div>

						<!-- Fichiers - url -->
						<div v-if="!simple_mode" class="mb-2 border rounded p-2">
							<div class="d-flex align-items-center" style="gap:0.75rem">
								<b-form-checkbox v-model="init_data.fichiers_url.active">Fichiers - url</b-form-checkbox>
								<b-form-radio v-if="init_data.fichiers_url.active" v-model="init_data_default" value="fichiers_url" @change="onInitDataDefaultChange">Par défaut</b-form-radio>
							</div>
							<div v-if="init_data.fichiers_url.active" class="mt-2 ml-3">
								<div class="d-flex align-items-center mb-1" style="gap:0.5rem">
									<label class="mb-0" style="white-space:nowrap">Format accepté (ex: .csv,.txt)</label>
									<b-input v-model="init_data.fichiers_url.type" size="sm" placeholder=".csv,.txt" style="max-width:200px"></b-input>
								</div>
								<b-form-checkbox v-model="init_data.fichiers_url.at_least_one_file">Au moins 1 fichier requis</b-form-checkbox>
							</div>
						</div>

						<!-- Fichier CSV -->
						<div class="mb-2 border rounded p-2">
							<div class="d-flex align-items-center" style="gap:0.75rem">
								<b-form-checkbox v-model="init_data.fichier.active">Fichier CSV</b-form-checkbox>
								<b-form-radio v-if="init_data.fichier.active" v-model="init_data_default" value="fichier" @change="onInitDataDefaultChange">Par défaut</b-form-radio>
							</div>
							<div v-if="init_data.fichier.active" class="mt-2">
								<p class="mb-1"><small class="text-muted">Valeurs initiales</small></p>
								<edit_tabulator
									:extern_file="true"
									:columns_type="{}"
									ref="fichier_init_tabulator"
									@update="onFichierInitUpdate"></edit_tabulator>
							</div>
						</div>

						<!-- Documents -->
						<div v-if="!simple_mode" class="mb-2 border rounded p-2">
							<div class="d-flex align-items-center" style="gap:0.75rem">
								<b-form-checkbox v-model="init_data.documents.active">Documents</b-form-checkbox>
								<b-form-radio v-if="init_data.documents.active" v-model="init_data_default" value="documents" @change="onInitDataDefaultChange">Par défaut</b-form-radio>
							</div>
							<div v-if="init_data.documents.active" class="mt-2 ml-3">
								<div class="d-flex align-items-center mb-1" style="gap:0.5rem">
									<label class="mb-0" style="white-space:nowrap">Dossier</label>
									<b-input v-model="init_data.documents.folder" size="sm" style="max-width:250px"></b-input>
								</div>
								<div class="d-flex align-items-center mb-1" style="gap:0.5rem">
									<label class="mb-0" style="white-space:nowrap">Extension</label>
									<b-input v-model="init_data.documents.extension" size="sm" style="max-width:150px"></b-input>
								</div>
								<b-form-checkbox v-model="init_data.documents.id_prefix">Préfixer les fichiers de l'id</b-form-checkbox>
							</div>
						</div>

						<!-- Base de données -->
						<div class="mb-2 border rounded p-2">
							<div class="d-flex align-items-center" style="gap:0.75rem">
								<b-form-checkbox v-model="init_data['base de données'].active">Base de données</b-form-checkbox>
								<b-form-radio v-if="init_data['base de données'].active" v-model="init_data_default" value="base de données" @change="onInitDataDefaultChange">Par défaut</b-form-radio>
							</div>
							<div v-if="init_data['base de données'].active" class="mt-2 ml-3">
								<div class="d-flex align-items-center mb-2" style="gap:0.5rem">
									<label class="mb-0" style="white-space:nowrap">Table par défaut</label>
									<b-input v-model="init_data['base de données'].table" size="sm" style="max-width:250px"></b-input>
								</div>
								<p class="mb-1"><strong>Configuration de la base de données</strong></p>
								<database
									@update="initial_database"
									:name="false"
									:change_table="true"
									:edit="false"
									ref="initial_database"></database>
							</div>
						</div>

						<!-- Base de données multitables -->
						<div v-if="!simple_mode" class="mb-2 border rounded p-2">
							<div class="d-flex align-items-center" style="gap:0.75rem">
								<b-form-checkbox v-model="init_data['base de données multitables'].active">Base de données multitables</b-form-checkbox>
								<b-form-radio v-if="init_data['base de données multitables'].active" v-model="init_data_default" value="base de données multitables" @change="onInitDataDefaultChange">Par défaut</b-form-radio>
							</div>
						</div>

						<!-- Pas de données initiales -->
						<div class="mb-2 border rounded p-2">
							<div class="d-flex align-items-center" style="gap:0.75rem">
								<b-form-checkbox v-model="init_data.no.active">Pas de données initiales</b-form-checkbox>
								<b-form-radio v-if="init_data.no.active" v-model="init_data_default" value="no" @change="onInitDataDefaultChange">Par défaut</b-form-radio>
							</div>
						</div>

						<!-- Google Sheet -->
						<div v-if="!simple_mode" class="mb-2 border rounded p-2">
							<div class="d-flex align-items-center" style="gap:0.75rem">
								<b-form-checkbox v-model="init_data.google_sheet.active">Google Sheet</b-form-checkbox>
								<b-form-radio v-if="init_data.google_sheet.active" v-model="init_data_default" value="google_sheet" @change="onInitDataDefaultChange">Par défaut</b-form-radio>
							</div>
						</div>

						<!-- Airtable -->
						<div v-if="!simple_mode" class="mb-2 border rounded p-2">
							<div class="d-flex align-items-center" style="gap:0.75rem">
								<b-form-checkbox v-model="init_data.airtable.active">Airtable</b-form-checkbox>
								<b-form-radio v-if="init_data.airtable.active" v-model="init_data_default" value="airtable" @change="onInitDataDefaultChange">Par défaut</b-form-radio>
							</div>
						</div>

				</div><!-- fin section Données de traitement -->

				<!-- Section Paramètres de traitement -->
					<div id="section-params" class="scenario-section" v-show="!simple_mode && panel_section != 'donnees' && !onboarding_data_mode">
						<h3 class="section-title">Paramètres de traitement <b-button variant="link" style="padding:1px" v-b-tooltip.hover title="Variables configurables par l'utilisateur avant de lancer un traitement (ex: date, filtre, seuil…). Chaque étape peut déclarer les paramètres dont elle a besoin, ils sont listés ici et saisis via l'interface de lancement."><i class="fas fa-info-circle"></i></b-button></h3>

						<!-- Éditeur de configuration (concepteur de scénario) -->
						<treatment_params_config
							v-model="user_params"
							:steps="steps_for_config"
							ref="treatment_params_config"
						></treatment_params_config>
						<div class="border rounded p-2 mb-2">
							<div class="d-flex align-items-center" style="cursor:pointer;user-select:none" @click="collapse_params_save = !collapse_params_save">
								<p class="mb-0 font-weight-bold flex-grow-1">Sauvegarde des configurations de paramètres</p>
								<i :class="collapse_params_save ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" class="ml-2"></i>
							</div>
							<b-collapse v-model="collapse_params_save">
								<p class="small text-muted mb-2 mt-2">
									Permettent de sauvegarder et recharger des jeux de valeurs pour les paramètres de ce scénario (ex : config prod, config test…).
									Remplissez la clé pour activer le formulaire de sauvegarde ci-dessous.
								</p>
								<b-form-group
									label="Nom du groupe de configurations"
									label-size="sm"
									v-b-tooltip.hover
									title="Saisir un nom pour activer la sauvegarde. Toutes les configurations sauvegardées sous ce nom seront disponibles au chargement. Ex : 'facturation', 'import-clients'. Laissez vide pour désactiver la sauvegarde.">
									<b-input v-model="user_params_save" placeholder="Ex : import-clients" size="sm" />
								</b-form-group>
								<b-form-group
									label="Configuration chargée par défaut"
									label-size="sm"
									v-b-tooltip.hover
									title="Nom de la configuration chargée automatiquement à l'ouverture. Doit correspondre à une configuration existante dans la bibliothèque.">
									<b-input v-model="user_params_save_default" placeholder="Ex : config-standard" size="sm" />
								</b-form-group>
							</b-collapse>
						</div>
						<treatment_params :type_save="user_params_save" :type_save_default="user_params_save_default" :files="steps.length > 0 ? steps[0].prev_files : []" :data="tabulator_import_data" @get_initial_files="get_initial_files" ref="treatment_params" @configuration="set_configuration" @values_change="on_test_values_change"></treatment_params>
				</div><!-- fin section Paramètres -->

					<!-- Section Tags -->
				<div id="section-tags" class="scenario-section" v-show="!simple_mode && panel_section != 'donnees' && !onboarding_data_mode">
					<h3 class="section-title">Tags <b-button variant="link" style="padding:1px" v-b-tooltip.hover title="Permettent à d'autres scénarios d'appeler uniquement un sous-ensemble d'étapes de ce scénario. Chaque tag définit une plage d'étapes (début → fin) identifiée par un nom."><i class="fas fa-info-circle"></i></b-button></h3>
					<table v-if="tags && tags.length > 0" class="table table-sm mb-2">
						<thead>
							<tr>
								<th>Nom</th>
								<th>Étape début</th>
								<th>Étape fin</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(tag, idx) in tags" :key="idx">
								<td>
									<input
										class="form-control form-control-sm"
										:class="tag.name ? 'is-valid' : ''"
										:value="tag.name"
										placeholder="Nom"
										@input="e => { var f = e.target.value.replace(/[^a-zA-Z0-9_]/g, ''); e.target.value = f; $set(tag, 'name', f); }"
									>
								</td>
								<td><b-select v-model="tag.start_uid" :options="stepsOptionsStart" size="sm"></b-select></td>
								<td><b-select v-model="tag.end_uid" :options="stepsOptionsEnd" size="sm"></b-select></td>
								<td><b-button variant="link" size="sm" @click="tags.splice(idx, 1)"><i class="fas fa-trash text-danger"></i></b-button></td>
							</tr>
						</tbody>
					</table>
					<div v-else class="text-muted mb-2 small">Aucun tag</div>
					<b-button variant="outline-secondary" size="sm" @click="tags.push({name:'', start_uid: steps.length > 0 ? steps[0].uid : null, end_uid: steps.length > 0 ? steps[steps.length-1].uid : null})">
						<i class="fas fa-plus mr-1"></i>Ajouter un tag
					</b-button>
				</div><!-- fin section Tags -->

				</div><!-- fin scenario-sections -->
				</div><!-- fin scenario-grid -->

				<!-- Composants cachés — refs nécessaires pour save/load/get_data (compatibilité données) -->
				<div style="display:none">
					<edit_tabulator
						:columns_type="tabulator_columns_type"
						:extern_file="false"
						ref="intermediate_tabulator"></edit_tabulator>
					<edit_tabulator
						:columns_type="tabulator_columns_type"
						@update="update_final_data"
						ref="final_tabulator"></edit_tabulator>
				</div>

				</div>
			<div v-show="state == 'etape'">
				<b-container style="margin: 0; padding: 0; max-width: none">
					<b-row
						ref="div_row"
						style="
							flex-wrap: nowrap !important;
							margin: 0;
							padding: 0;
							max-width: none;
						">
						<b-col
							ref="div_menu"
							md="auto"
							:class="{ 'scenario-locked-by-test': codegenFocusMode }"
							style="margin: 0; padding: 0; max-width: none">
							<h6 v-if="config || config_name">
							Scenario {{ name.substring(0, 30) }}{{ name.length > 30 ? "..." : "" }}
							<b-badge v-if="current_scenario_archived" variant="warning" class="ml-1" style="font-size:0.7em; vertical-align:middle;" title="Ce scénario est archivé"><i class="fas fa-archive mr-1"></i>Archivé</b-badge>
						</h6>

						<div class="toolbar-btns">
						<b-button
						class="bouton"
						:variant="state == 'configuration' && panel_section != 'donnees' ? 'primary' : 'secondary'"
						title="Configuration"
						@click="set_state('configuration')"
						><i class="fas fa-cogs"></i></b-button>
					<b-button
						class="bouton"
						:variant="panel_section == 'donnees' ? 'primary' : 'secondary'"
						title="Données initiales"
						@click="set_state('données')"
						><i class="fas fa-table"></i></b-button>
					<b-button
						class="bouton"
						:variant="state == 'etape' ? 'primary' : 'secondary'"
						title="Étapes"
						@click="set_state('etape')"
						><i class="fas fa-list"></i></b-button>
					<b-button
						class="bouton"
						v-if="config && name && version"
						variant="secondary"
						title="Sauvegarder"
						@click="save_db(false, false)"
						><i class="fas fa-save"></i></b-button>
					<b-button
						class="bouton"
						variant="secondary"
						title="Nouveau scénario"
						@click="nouveau_scenario"
						><i class="fas fa-plus"></i></b-button>
					</div>

						<div class="mt-1">Etapes
							<i
								class="fas fa-plus-square cursor-pointer"
								@click="stepPickerOpen = true"
								title="Ajouter une étape"></i>
							<i
								v-if="test_checkpoints.length === 0 && steps.length > 0 && !simple_mode"
								class="fas fa-flag cursor-pointer ml-1"
								style="color:#f0a500;"
								@click="addCheckpoint()"
								title="Ajouter un checkpoint"></i>
						</div>
							<!-- * scrollable -->
							<div class="max-h-[75vh] overflow-y-scroll">
								<!-- * ne charge pas pendant qu'on modifie steps!
                        * cf stepsLoaded, mais attention à quand on rajoute une étape
                     -->
								<draggable
									group="step"
									:value="sidebar_items"
									@input="on_sidebar_input"
									class="list-group">
									<div
										v-for="item in sidebar_items"
										:key="item.id">
										<!-- Repère de test -->
										<div
											v-if="item._type === 'checkpoint' && !simple_mode"
											class="test-checkpoint-sidebar-item"
											:class="{ active: view_checkpoint }"
											@click="view_checkpoint = true; view_step = ''; stepPickerOpen = false;"
										>⚑ Checkpoint</div>
										<!-- Étape -->
										<span v-if="item._type === 'step'">
                                            <b-button
                                                :title="requiresTooltip[item._orig_idx]"

												style="
													text-align: left !important;
												"
												variant="link"
												@click="
													view_step = item.id;
													view_idx = item._orig_idx;
													stepPickerOpen = false;
													view_checkpoint = false;
												"
												:style="'color:' + steps[item._orig_idx].status + '; font-weight:' + (view_step == item.id ? 'bold' : 'normal')"
												>{{ item._orig_idx + 1 }} -
												{{
													(steps[item._orig_idx].description || (steps[item._orig_idx].load_data && steps[item._orig_idx].load_data.description) || steps[item._orig_idx].data.label || 'nouvelle étape').substring(0, 30)
												}}
												{{ steps[item._orig_idx].description ? steps[item._orig_idx].description.length > 30 ? "..." : "" : "" }}
                                                {{ requiresTooltip[item._orig_idx].length > 0 ? "*" : "" }}
												<span
													v-if="active_source_positions.has(String(item._orig_idx + 1))"
													title="Source de l'étape sélectionnée"
													style="color: #17a2b8; margin-left: 4px;"
													><i class="fas fa-arrow-right"></i></span>
												<span
													v-if="(steps[item._orig_idx].errors && steps[item._orig_idx].errors.length) > 0"
													style="color: red"
													>!</span>
											</b-button>
										</span>
										<div style="text-align: left !important;" v-if="item._type === 'step' && steps[item._orig_idx].data.action == 'group'">
											<!-- recursive composant menu, les étapes peuvent entrer et sortir du groupe -->
											&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Fin du groupe
										</div>
									</div>
								</draggable>
							</div>
						</b-col>

						<b-col ref="div_steps">
							<!-- Picker plein écran -->
							<div v-if="stepPickerOpen">
								<StepPickerV2 @select="onPickStep" :title="steps.length === 0 ? 'Choisir une première étape' : 'Ajouter une étape'" :simple_mode="simple_mode" :excluded_actions="simple_mode ? ['base de données', 'firecrawl', 'send_notifications', 'agenda', 'api'] : []" />
							</div>
							<!-- Repère de test (panneau de configuration) -->
							<template v-if="test_checkpoints.length > 0 && !stepPickerOpen">
							<div v-show="view_checkpoint">
								<i
									class="ml-2 cursor-pointer text-[--theme-text-color] fa fa-times close"
									@click="view_checkpoint = false"></i>
								<h6 class="ml-2 mt-1" style="color:#856404;">⚑ Checkpoint</h6>
								<TestCheckpoint
									ref="checkpoint_panel"
									:checkpoint="test_checkpoints[0]"
									:tables="tables"
									@remove="removeCheckpoint(); view_checkpoint = false;"
									@update="updateCheckpoint"
									@refresh="refreshCheckpointData"
								/>
							</div>
						</template>
							<!-- Étapes (toujours montées pour que @change soit émis) -->
							<div v-show="!stepPickerOpen">
							<!-- * ne charge pas pendant qu'on modifie steps!
                    * cf stepsLoaded, mais attention à quand on rajoute une étape
                 -->
							<div
								v-for="(element, idx) in steps"
								:key="element.id">
								<div
									v-show="view_step == element.id">
									<step
										:action_id="element.id"
										v-on:set_action="set_action(element.id)"
										@remove_step="removeAt(idx)"
										@make_list="make_list"
										@test="test"
										@test_by_line="test_by_line"
										@stop_test="f_stop_test"
										@change_status="change_status"
										@change_errors="change_errors"
										@change="change"
										@change_user_params="change_user_params"
										@create_scenario_param="create_scenario_param"
										@add_param_target="add_param_target"
										@remove_param_target="remove_param_target"
				@edit_scenario_param="edit_scenario_param"
										@open_create_scenario_param="open_create_scenario_param"
										@test_from_checkpoint="test_all_from_checkpoint"
										@name_file_changed="onStepNameFileChanged(element.id, $event)"
										@check_uid="onCheckUid(element.id, $event)"
										@codegen-test-mode="onCodegenTestMode"
										:scenario_params="scenario_params_merged"
										:simple_mode="simple_mode"
										:prev_files="element.prev_files || []"
										:prev_urls="element.prev_urls"
										:projects="list_projects"
										:projects_archive="list_projects_archive"
										:ref="element.id"
										:cible_data="final_tabulator_data"
										:load_data="element.load_data"
										:id="element.id"
										:prev_data="element.prev_data"
										:columns="tabulator_columns_data"
										:tables="tables"
						:db_schema="db_schema"
										:size="size"
										:client="client"
										:list_words="listWords"
										:columns_type="tabulator_columns_type"
										:user_params_config="user_params_config"
										:user_params_test="user_params_test"
										:project_uid="project_uid"
										:step_position="idx"
										:lines_mode="lines_mode"
										:lines_nb="lines_nb"
										:readonly_action="true"
										:checkpoint="checkpointForStep(element.id)"
										:steps_list="steps_list"
										:scenario_uid="uid"
										>
									</step>
									<!--  group step, recursif, composant avec les sous étapes eet les fonctions de test -->
								</div>
							</div>
							</div>
						</b-col>
					</b-row>
				</b-container>
			</div>
		</div>
		</div> <!-- fin v-else onboarding -->
	</div>
</template>

<script>
	import Tabulator from 'tabulator-tables/dist/js/tabulator.min.js';

	import "../../public/js/query-builder.default.min.css";
	import "../../public/js/query-builder.min.js";
	import "../../public/js/query-builder-fr.js";

	const serialize = require("form-serialize");
	const clone = require("clone");

	const {Condition} = require("../utils/Condition");

	import { JSONEditor } from "@json-editor/json-editor";
	import uniqueId from "lodash.uniqueid";
	import draggable from "vuedraggable";
	import * as json2csv from "json2csv";
	import alasql from "alasql";
	import $ from "jquery";

	import store from "../store";
	import users from "../services/users.js";
	import utils from "../services/utils.js";
	import step from "../components/Step.vue";

	import tools from "../utils/Tools";
	import library from "../views/Library.vue";
	import element from "../services/element.js";
	import ensemble from "../views/Ensemble.vue";
	import workers from "../services/workers.js";
	import documents from "../views/Document.vue";
	import scenario from "../services/scenario.js";
	import projects from "../services/projects.js";
	import database from "../services/database.js";
	import databaseView from "../views/database.vue";
	import treatments from "../services/treatments.js";
	import listWords from "../components/listWords.vue";
	import file_upload from "../components/file_upload.vue";
    import array_editor from "../components/array_editor.vue";
	import edit_tabulator from "../components/edit_tabulator.vue";
	import draggable_tree from "../components/draggable_tree.vue";
	import treatment_params from "../components/treatment_params.vue";
	import treatment_params_config from "../components/treatment_params_config.vue";
	import DatabaseRequestView from "../views/DatabaseRequestView.vue";
    import InitDataGsheets from "../components/Project_v2/init_data_gsheets.vue";
    import InitDataAirtable from "../components/Project_v2/init_data_airtable.vue";
	import StepPickerV2 from "../components/StepPickerV2.vue";
	import TestCheckpoint from "../components/TestCheckpoint.vue";

	export default {
		name: "project",
		components: {
			edit_tabulator,
			listWords,
			draggable,
			step,
			database: databaseView,
			ensemble,
			"files-upload": file_upload,
			"draggable-tree": draggable_tree,
			StepPickerV2,
			treatment_params,
			treatment_params_config,
			documents,
			DatabaseRequestView,
			array_editor,
			InitDataGsheets,
			InitDataAirtable,
			TestCheckpoint,
		},
		props: {
			state_prop: {
				default: "",
			},
			initial_method_prop: {
				default: "",
			},
			config: {
				default: true,
			},
			config_name: {
				default: false,
			},
		},
		data() {
			return {
				user: {},
				ready: 0,

				client: {},
				ro: null,
				ro_test: null,
				size: 0,
				size_test: 0,

				state: (this.$route && this.$route.params && this.$route.params.id) ? "etape" : "configuration",
				state_test: "configuration",

				id: uniqueId(""),

				env_list: [""],
				sync_env: [],

				project: "",
				project_uid: this.$uuid.v4(),
				// Identifiant du scénario/projet en cours d'édition. Volontairement
				// déclaré ici (même vide au départ) et non seulement assigné plus
				// tard via `this.uid = ...` : sans ça, `this.uid` référencé dans le
				// template (ex. `:scenario_uid="uid"`) n'existe pas encore sur
				// l'instance lors du tout premier rendu -> warning Vue "Property or
				// method 'uid' is not defined on the instance".
				uid: "",
				list_projects: [],
				projects_options: [],
				project_data: {},

				tests: {
					configuration: {
						end: false,
					},
					tests: [],
				},
				test_id: null,

				list_projects_archive: [],
				list_projects_archive_libelle: [],
				projects_archive_options: [],
				unarchive_uid: "",

				archive_filter: 'all',
				archive_last_treatments: {},
				archive_loading_treatments: false,

				first_test_done: false,

				initial_method_options: [
					{ value: "fichier", text: "fichier csv"},
					"base de données",
					"base de données multibases",
					"ensemble",
					"fichiers",
					"documents",
                    "Google sheets",
					"Airtable",
					"fichiers - url"
				],
				initial_method: "fichier",
				tables: [],
				db_schema: {},
				db_schema_loading: false,
				table: "",

				tabulator_import_data: null,
				name_file_init: 'data.csv',
				tabulator_columns_type: {},
				tabulator_columns_type_new: "",

				tabulator_columns: null, // Instance Tabulator
				tabulator_columns_data: [{ colonne: "", type: "texte" }],
				tabulator_columns_options: {
					paginationSize: 10,
					pagination: "local",
					columns: [
						{
							title: "colonne",
							field: "colonne",
							editor: "input",
						},
						{
							title: "type",
							field: "type",
						editor: "list",
						editorParams: {
							values: ["texte", "nombre"],
						},
					},
				],
			},

			steps: [],
			// Repère(s) de test — non persistés, éphémères, un seul pour l'instant
			// Stocké en tableau pour faciliter l'extension future à plusieurs repères
			test_checkpoints: [],
			results: false,
			script_logs: [],

		missing_columns: null,
		final_tabulator_data: [],
		tabulator_data: null,
		collapse: true,

		tabIndex: 0,
		simple_mode: false,
		redraw: true,

		listWords: [],
		tabListIndex: 0,
		collapse_list: true,

		name: "",
		version: "",
		_version: "",
		description: "",
		description_project: "",
		short_description_project: "",
		comment_project: "",
		version_test: false,
		version_prod: true,
		version_env: false,

		list_name: [],
		list_version: [],
		next_version: 1,
		save_exist: false,
		prod_version: "",

		load_name: "",
		load_version: "",

		new_name: "",

		view_step: "",
		view_checkpoint: false,
		view_idx: 0,

		config_index: 0,
		panel_section: 'scenario',
		prev_panel_section: 'scenario',
		prev_scroll_top: 0, // position de scroll exacte sauvegardée

		tags: [],
		treatment_actions: [],
		init_data: {
			fichiers:                    { active: true,  default: false, type: "", at_least_one_file: false },
			fichiers_url:                { active: false, default: false, type: "", at_least_one_file: false },
			fichier:                     { active: false, default: false, init: [] },
			documents:                   { active: false, default: false, folder: "", extension: "", id_prefix: false },
			"base de données":           { active: false, default: false, table: "", params: null },
			"base de données multitables": { active: false, default: false },
			no:                          { active: false, default: false },
			google_sheet:                { active: false, default: false },
			airtable:                    { active: false, default: false },
		},

		editor: null,
		editor_actions: null,
		editor_init: null,

		stepsLoaded: false,

		stepPickerOpen: false,

		// Mode "test en place" du g\u00e9n\u00e9rateur de code (TODO_CODEGEN_CHAT.md
		// section 10, proposition v4) : quand une \u00e9tape bascule son CodeGenerator
		// en mode test (cf steps/fonction.vue::enterTestMode), on verrouille la
		// navigation vers les autres \u00e9tapes et l'enregistrement du sc\u00e9nario tant
		// que l'utilisateur n'a pas valid\u00e9/quitt\u00e9 explicitement ce mode.
		codegenFocusMode: false,

		// Onboarding
		onboarding: true,
		onboarding_screen: 'home', // 'home' | 'create' | 'load'
		onboarding_name: '',
		onboarding_name_error: '',
		onboarding_checking: false,
		onboarding_load_search: '',
		onboarding_load_loading: false,
		onboarding_show_archived: false,
		modal_load_show_archived: false,
		onboarding_data_mode: false, // true quand on est en section données depuis l'onboarding
		onboarding_simple_mode: true, // choix du mode sur l'écran de création

		scenario_loading: !!(this.$route && this.$route.params && this.$route.params.id),

		inDropdownTraitements: true,
		inDropdownPostTreatments: false,
				generating_descriptions: false,
				description_progress: 0,
				description_current: 0,

				user_params: [],
				user_test_values: {},
				user_params_test: true,
				user_params_save: "",
				collapse_params_save: false,
				user_params_save_default: "",
				user_params_config: "",

				active_watch: true,
				render_files: true,
				browser: true,
				sub_treatment: false,
				next_treatments: [],

				columns_result: [],

				stop_test: false,

				lines: false,
				lines_mode: false,
				steps_lines: [],
				lines_nb: 1,
				generating_project_description: false,
				generate_only_empty_descriptions: true,
				custom_prompt_project: "",
				show_custom_prompt_project: false,

				init_data_default: null,
				init_data_type_defs: [
					{ key: "fichiers",                  label: "Fichiers" },
					{ key: "fichiers_url",              label: "Fichiers - url" },
					{ key: "fichier",                   label: "Fichier CSV" },
					{ key: "documents",                 label: "Documents" },
					{ key: "base de données",           label: "Base de données" },
					{ key: "base de données multitables", label: "Base de données multitables" },
					{ key: "no",                        label: "Pas de données initiales" },
					{ key: "google_sheet",              label: "Google Sheet" },
					{ key: "airtable",                  label: "Airtable" },
				],
			};
		},
		watch: {
			name_file_init(val) {
				// Propager immédiatement le nom vers la première étape (données précédentes)
				if (this.steps.length > 0) {
					const firstId = this.steps[0].id;
					if (this.$refs[firstId] && this.$refs[firstId][0]) {
						this.$refs[firstId][0].prev_name_file = val || 'data.csv';
					}
				}
			},
			user_params: {
				deep: true,
				async handler(val) {
					if (this.$refs.treatment_params) {
						await this.$nextTick();
						this.$refs.treatment_params.is_set = false;
						await this.$refs.treatment_params.set(this.normalize_params_for_form(val));
					}
				}
			},
			user_params_test: {
				async handler(val) {
					if (val && this.$refs.treatment_params) {
						await this.$nextTick();
						this.$refs.treatment_params.is_set = false;
						await this.$refs.treatment_params.set(this.normalize_params_for_form(this.user_params));
					}
				}
			},
			steps: {
				handler(val) {
					if (val.length === 0) this.stepPickerOpen = true;
				},
				immediate: true,
			},
			tabulator_columns_data: {
				handler(newData) {
					if (this.tabulator_columns && newData) {
						this.tabulator_columns.replaceData(newData);
					}
				},
				deep: true
			},
			'$route.params.id': {
				async handler () {
					//console.log(this.$route.params.id)
					if (this.uid != this.$route.params.id)
					{
						var sc = await scenario.getby_id(this.$route.params.id);
						if (sc && sc.length > 0)
						{
							this.active_watch = false;
							this.load_name = sc[0].libelle;
							await this._prefetch_list_version(sc[0].libelle, sc[0].version);
							await this.load_db();
							this.active_watch = true;
							this.set_state('etape');
						}
					}
				}
			},
			inDropdownTraitements: {
				handler() {
					this.project_data.inDropdownTraitements =
						this.inDropdownTraitements;
				},
			},
			inDropdownPostTreatments: {
				handler() {
					this.project_data.inDropdownPostTreatments =
						this.inDropdownPostTreatments;
				},
			},
			tabIndex: {
				handler() {
					// final_tabulator n'est plus dans un onglet, redraw non nécessaire
				},
			},
			load_name: {
				async handler(newVal, oldVal) {
					// Vérifier que load_name existe et n'est pas vide
					if (!newVal || newVal === '') {
						return;
					}
					// Si le watch est désactivé (ex: chargement depuis onboarding), on ignore dès le début
					if (!this.active_watch) return;

					var scenarios = await scenario.getby_libelle(
						newVal
					);

					if (!scenarios) return;

					this.list_version = [];
					for (var i = 0; i < scenarios.length; i++) {
						if (i == 0 && this.active_watch) 
							this.load_version = scenarios[i].version;
						this.list_version.push({"description": scenarios[i].description, "value": scenarios[i].version, "text" : scenarios[i].dateheure + " - v " + scenarios[i].version});
					}

					if (this.active_watch)
						await this.load_db();
				},
			},
		},
        computed: {
				scenario_params_merged() {
					const tv = this.user_test_values;
					return (this.user_params || []).map(p => {
						const v = tv[p.name];
						return v !== undefined ? Object.assign({}, p, { value: v }) : p;
					});
				},

			// Retourne le checkpoint si cette étape est APRÈS lui, null sinon
			checkpointForStep() {
				return (step_id) => {
					if (this.test_checkpoints.length === 0) return null;
					const cp = this.test_checkpoints[0];
					const after_idx = this.steps.findIndex(s => s.id === cp.after_step_id);
					const step_idx = this.steps.findIndex(s => s.id === step_id);
					// L'étape est après le repère si son index > after_idx (after_idx=-1 si null → toutes les étapes)
					if (step_idx > after_idx) return cp;
					return null;
				};
			},
			// Liste fusionnée étapes + repère de test pour le draggable sidebar
			sidebar_items() {
				const result = [];
				// Repère avant toutes les étapes (after_step_id === null)
				if (this.test_checkpoints.length > 0 && this.test_checkpoints[0].after_step_id === null) {
					result.push({ _type: 'checkpoint', id: '__cp__' });
				}
				for (let i = 0; i < this.steps.length; i++) {
					result.push({ _type: 'step', id: this.steps[i].id, _orig_idx: i });
					if (this.test_checkpoints.length > 0 && this.steps[i].id === this.test_checkpoints[0].after_step_id) {
						result.push({ _type: 'checkpoint', id: '__cp__' });
					}
				}
				return result;
			},
			/**
			 * Liste des étapes avec leur uid réel, description et action.
			 * Utilisé par treatment_params_config pour le sélecteur d'étapes.
			 */
			steps_for_config() {
				var all_projects = [
					...this.list_projects,
					...this.list_projects_archive,
				];
				return this.steps.map((s, idx) => {
					var uid = s.load_data && s.load_data.data ? s.load_data.data.uid : null;
					var action = s.load_data ? (s.load_data.action || "") : "";
					var child_params = [];
					if (action.toLowerCase() === "projet") {
						var project_id = s.load_data ? s.load_data.project_id : null;
						var proj = all_projects.find(p => p.uid === project_id);
						if (proj && proj.details) {
							var env = this.user && this.user.env;
							var env_tp = env && proj.details.env && proj.details.env[env] && Array.isArray(proj.details.env[env].treatment_params)
								? proj.details.env[env].treatment_params
								: null;
							child_params = env_tp || (Array.isArray(proj.details.treatment_params) ? proj.details.treatment_params : []);
						}
					}
					return {
						uid,
						description: s.description || null,
						action: action.toLowerCase(),
						position: idx + 1,
						child_params,
					};
				}).filter(s => s.uid);
			},
			onboarding_load_filtered() {
					const q = (this.onboarding_load_search || '').toLowerCase();
					return this.list_name.filter(s => !q || (s.text && s.text.toLowerCase().includes(q)));
				},
			onboarding_archived_filtered() {
				const q = (this.onboarding_load_search || '').toLowerCase();
				return this.list_projects_archive
					.filter(p => !q || (p.libelle && p.libelle.toLowerCase().includes(q)))
					.map(p => ({
						text: p.libelle,
						value: p.libelle,
						uid: p.uid,
						description: p.details && p.details.description_project ? p.details.description_project : null,
						archived: true,
					}));
			},
			current_scenario_archived() {
				return this.name && this.list_projects_archive_libelle.includes(this.name);
			},
			filtered_initial_method_options() {
				if (!this.simple_mode) return this.initial_method_options;
				const allowed = new Set(['fichier', 'fichiers', 'base de données']);
				return this.initial_method_options.filter(opt => {
					const val = typeof opt === 'string' ? opt : opt.value;
					return allowed.has(val);
				});
			},
				_canGenerateIa() {
					const rules = store.state.user ? store.state.user.rules : undefined;
					if (rules === null) return true;
					return !!(rules && rules.generate_ia);
				},
					archive_table_fields() {
					const fields = [
						{ key: 'libelle', label: 'Nom', sortable: true },
					];
					if (Object.keys(this.archive_last_treatments).length > 0)
						fields.push({ key: 'last_treatment', label: 'Dernier traitement', sortable: true });
					fields.push({ key: 'test_date', label: 'Dernier test éditeur', sortable: true });
					fields.push({ key: 'archive', label: 'Statut', sortable: true });
					fields.push({ key: 'actions', label: 'Actions' });
					return fields;
				},
				projects_filtered_for_archive() {
					const all = [
						...this.list_projects.map(p => ({ ...p, archive: false })),
						...this.list_projects_archive.map(p => ({ ...p, archive: true })),
					];
					all.forEach(p => {
						const v = this.archive_last_treatments[p.uid];
						p.last_treatment = v !== undefined ? v : null;
						const fd = p.details && p.details.test_date;
						p.test_date = fd ? fd.replace('T', ' ').substring(0, 16) : null;
					});
					all.sort((a, b) => (a.libelle || '').localeCompare(b.libelle || '', 'fr', { sensitivity: 'base' }));
					if (this.archive_filter === 'active')
						return all.filter(p => !p.archive);
					if (this.archive_filter === 'archived')
						return all.filter(p => p.archive);
					return all;
				},
            // * calculated *once* every time steps change
            requiresTooltip() {
                var needReload = false;

                var self = this;

                var requireTooltipArr = this.steps.map((step, idx) => {
                    var stepTooltip = "";

                    stepTooltip += (step.source_data && step.source_data.length > 0) ? `Source data: ${step.source_data}\n` : "";

                    // convert array of strings to strnig

                    stepTooltip += (self.stepTags[idx].length > 0) ? `Tags: ${self.stepTags[idx]}\n` : "";
                    stepTooltip += (step.data && step.data.parameters !== undefined && (step.data.parameters.cut_start)) ? `Cut start: ${step.data.parameters.cut_start}` : "";	
					stepTooltip += (step.data && step.data.parameters !== undefined && (step.data.parameters.cut_end)) ? `Cut end: ${step.data.parameters.cut_end}` : "";	
					stepTooltip += (step.data && step.data.notifications) ? `Notifications saas` : "";	

                    needReload |= stepTooltip;

                    return stepTooltip;
                });

                if (needReload)
                    this.$forceUpdate();

                return requireTooltipArr;
            },
            active_source_positions() {
                if (!this.view_step) return new Set();
                const current = this.steps.find(s => s.id === this.view_step);
                if (!current || !current.source_data) return new Set();
                return new Set(current.source_data.split("|").map(s => s.trim()).filter(Boolean));
            },
            steps_list() {
                var list = [{ uid: "import", position: 0, label: "Import (données initiales)" }];
                for (var i = 0; i < this.steps.length; i++) {
                    var s = this.steps[i];
                    list.push({
                        uid: s.uid,
                        position: i + 1,
                        label: s.description || (s.load_data && s.load_data.description) || (s.data && s.data.label) || ("Étape " + (i + 1))
                    });
                }
                return list;
            },
            // * calculated *once* every time steps change
            stepTags() {
                var self = this;
                return this.steps.map((step, idx) => {
                    var tags = "";

					if (self.tags)
					{
						for (let i = 0; i < self.tags.length; i++) {
							var startIdx = self.tags[i].start_uid ? self.steps.findIndex(function(s) { return s.uid === self.tags[i].start_uid; }) : 0;
							var endIdx = self.tags[i].end_uid ? self.steps.findIndex(function(s) { return s.uid === self.tags[i].end_uid; }) : self.steps.length - 1;
							if (startIdx === -1) startIdx = 0;
							if (endIdx === -1) endIdx = self.steps.length - 1;
							if (idx >= startIdx && idx <= endIdx) {
								// * s'il yen a plus d'un, et qu'on est pas à la fin, on ajoute une virgule
								tags += self.tags[i].name + ((self.tags.length > 1 && i !== self.tags.length - 1) ?  ", " : "");
							}
						}
					}
                    return tags;
                });
            },
			stepsOptionsStart() {
				var opts = this.steps.map(function(step, idx) {
					return { value: step.uid, text: (idx + 1) + '. ' + (step.description || (step.load_data && step.load_data.description) || (step.data && step.data.label) || ('Étape ' + (idx + 1))) };
				});
				opts.unshift({ value: null, text: 'Depuis le début (étape 1)' });
				return opts;
			},
			stepsOptionsEnd() {
				var opts = this.steps.map(function(step, idx) {
					return { value: step.uid, text: (idx + 1) + '. ' + (step.description || (step.load_data && step.load_data.description) || (step.data && step.data.label) || ('Étape ' + (idx + 1))) };
				});
				opts.unshift({ value: null, text: 'Jusqu\'à la fin (dernière étape)' });
				return opts;
			}
        },
		methods: {

			// ── Repère de test ────────────────────────────────────────────────

		onStepNameFileChanged(step_id, new_name) {
				// Quand l'utilisateur modifie le nom dans le résultat de l'étape N,
				// propager immédiatement vers prev_name_file de l'étape N+1
				const idx = this.steps.findIndex(s => s.id === step_id);
				if (idx === -1 || idx >= this.steps.length - 1) return;
				const next_id = this.steps[idx + 1].id;
				if (this.$refs[next_id] && this.$refs[next_id][0]) {
					this.$refs[next_id][0].prev_name_file = new_name || 'data.csv';
				}
			},

			addCheckpoint() {
				// Positionner après l'étape courante si elle existe, sinon après la dernière
				let after_step_id = null;
				if (this.view_step && this.steps.find(s => s.id === this.view_step)) {
					after_step_id = this.view_step;
				} else if (this.steps.length > 0) {
					after_step_id = this.steps[this.steps.length - 1].id;
				}
				this.test_checkpoints = [{
					after_step_id: after_step_id,
					mode: 'live',
					data: [],
					snapshot_date: null,
					fixed_data: [],
				}];
			},

			removeCheckpoint() {
				this.test_checkpoints = [];
			},

			// Callback du draggable sidebar : met à jour l'ordre des étapes et la position du repère
			on_sidebar_input(new_list) {
				if (this.test_checkpoints.length > 0) {
					const cp_idx = new_list.findIndex(i => i._type === 'checkpoint');
					if (cp_idx === 0) {
						this.$set(this.test_checkpoints, 0, Object.assign({}, this.test_checkpoints[0], { after_step_id: null }));
					} else if (cp_idx > 0) {
						const before = new_list[cp_idx - 1];
						if (before && before._type === 'step') {
							this.$set(this.test_checkpoints, 0, Object.assign({}, this.test_checkpoints[0], { after_step_id: before.id }));
						}
					}
				}
				const new_steps = new_list
					.filter(i => i._type === 'step')
					.map(i => this.steps.find(s => s.id === i.id))
					.filter(Boolean);
				this.steps.splice(0, this.steps.length, ...new_steps);
				// Recalculer source_data (positions) après réorganisation
				this._recompute_source_data();
			},

			onCheckUid(stepId, payload) {
				// payload = [uid, callback]
				var uid = payload[0];
				var callback = payload[1];
				var isDuplicate = this.steps.some(function(s) {
					return s.uid === uid && s.id !== stepId;
				});
				callback(isDuplicate);
			},
			_recompute_source_data() {
				for (var i = 0; i < this.steps.length; i++) {
					var ids = this.steps[i].source_data_ids || [];
					if (ids.length > 0) {
						var positions = ids.map((uid) => {
							if (uid === "import") return "import";
							var idx = this.steps.findIndex(s => s.uid === uid);
							return idx >= 0 ? String(idx + 1) : null;
						}).filter(Boolean);
						this.steps[i].source_data = positions.join("|");
						this.$set(this.steps, i, this.steps[i]);
					}
				}
			},

			updateCheckpoint(state) {
				if (this.test_checkpoints.length === 0) return;
				this.test_checkpoints = [Object.assign({}, this.test_checkpoints[0], state)];
			},

			moveCheckpointUp() {
				if (this.test_checkpoints.length === 0) return;
				const cp = this.test_checkpoints[0];
				const idx = this.steps.findIndex(s => s.id === cp.after_step_id);
				if (idx <= 0) {
					// Déplacer avant toutes les étapes : after_step_id = null
					this.test_checkpoints = [Object.assign({}, cp, { after_step_id: null })];
				} else {
					this.test_checkpoints = [Object.assign({}, cp, { after_step_id: this.steps[idx - 1].id })];
				}
			},

			moveCheckpointDown() {
				if (this.test_checkpoints.length === 0) return;
				const cp = this.test_checkpoints[0];
				const idx = this.steps.findIndex(s => s.id === cp.after_step_id);
				if (idx >= this.steps.length - 1) return; // déjà à la fin
				this.test_checkpoints = [Object.assign({}, cp, { after_step_id: this.steps[idx + 1].id })];
			},

			async refreshCheckpointData() {
				if (this.test_checkpoints.length === 0) return;
				const cp = this.test_checkpoints[0];
				const after_idx = this.steps.findIndex(s => s.id === cp.after_step_id);
				let data, files, urls = [], name_file = 'data.csv';
				if (after_idx >= 0) {
					const stepRef = this.$refs[this.steps[after_idx].id][0];
					data = stepRef.get_data() || [];
					files = stepRef.get_data_files ? await stepRef.get_data_files(false) || [] : [];
					urls = stepRef.getUrls ? stepRef.getUrls() || [] : [];
					name_file = stepRef.get_name_file ? stepRef.get_name_file() : 'data.csv';
				} else {
					data = this.$refs.start_tabulator ? this.$refs.start_tabulator.get_data() || [] : [];
					files = this.$refs.start_tabulator ? await this.$refs.start_tabulator.get_data_files(false) || [] : [];
					name_file = this.name_file_init || 'data.csv';
				}
				if (this.$refs.checkpoint_panel) {
					this.$refs.checkpoint_panel.setSnapshot(data, files, name_file, urls);
				} else {
					this.updateCheckpoint({ data, snapshot_date: new Date().toLocaleString('fr-FR'), mode: 'copy' });
				}
			},

async test_all_from_checkpoint(target_step_id) {
					if (this.test_checkpoints.length === 0) return;
					const cp = this.test_checkpoints[0];
					const after_idx = this.steps.findIndex(s => s.id === cp.after_step_id);
					const start_idx = after_idx + 1;
					const end_idx = target_step_id ? this.steps.findIndex(s => s.id === target_step_id) : this.steps.length - 1;

					if (start_idx > this.steps.length - 1 || start_idx < 0) return;
					if (end_idx < start_idx) return;

				// Construire files_test pour la première étape selon le mode
				let files_test = null;
				let urls_test = null;

				if (cp.mode === 'copy') {
					// Lire les données depuis le composant si ouvert, sinon depuis cp.data
					const cpRef = this.$refs.checkpoint_panel || null;
					let rows = [];
					if (cpRef && cpRef.$refs.snapshot_tabulator) {
						rows = cpRef.$refs.snapshot_tabulator.get_data() || [];
					}
					if (!rows.length) rows = cp.data || [];

					const nonCsvFiles = cp.snapshot_files || [];
					const snapshot_urls = cp.snapshot_urls || [];
					const name_file = cp.snapshot_name_file || 'data.csv';

					// Injecter dans l'étape ancre exactement comme setResults le ferait
					// → test() lira get_data_files() et getUrls() normalement
					if (after_idx >= 0) {
						const anchorRef = this.$refs[this.steps[after_idx].id][0];
						if (anchorRef) {
							anchorRef.tabulator_data = rows;
							anchorRef.results_files = nonCsvFiles;
							anchorRef.name_file = name_file;
							anchorRef.urls = snapshot_urls;
						}
					} else if (rows.length > 0 && this.$refs.start_tabulator) {
						await this.$refs.start_tabulator.set_data(rows);
					}
					// Pas de files_test ni urls_test → test() lit get_data_files() + getUrls() normalement

				} else if (cp.mode === 'fixed') {
					const cpRef = this.$refs.checkpoint_panel || null;
					if (cpRef) {
						const fixedFiles = await cpRef.get_data_files() || [];
						if (fixedFiles.length > 0) files_test = fixedFiles;
					}
				}
				// mode 'live' : files_test = null → test() lit les données de l'étape ancre normalement

				// Lancer les étapes en séquence depuis le repère jusqu'à l'étape cible
				for (let i = start_idx; i <= end_idx; i++) {
					const s = this.steps[i];
					const stepRef = this.$refs[s.id] && this.$refs[s.id][0];
					if (!stepRef) continue;
					// files_test seulement pour la première étape, les suivantes lisent leurs données normalement
					const ft = i === start_idx ? files_test : null;
					const ut = i === start_idx ? urls_test : null;
					const stop = await this.test(
						stepRef,
						stepRef.get_id(),
						stepRef.get_params_data(),
						false,
						stepRef.get_keep_start_data(),
						stepRef.get_treatment(),
						0,
						ft,
						ut
					);
					if (stop) break;
				}
			},

			// ── Fin repère de test ────────────────────────────────────────────

			async generate_all_descriptions() {
				if (this.steps.length === 0) {
					this.$notify({
						group: 'info',
						type: 'error',
						title: 'Erreur',
						text: 'Aucune étape à traiter'
					});
					return;
				}

				this.generating_descriptions = true;
				this.description_progress = 0;
				this.description_current = 0;

				let generated_count = 0;
				let skipped_count = 0;

				for (let i = 0; i < this.steps.length; i++) {
					this.description_current = i + 1;
					
					try {
						const stepRef = this.$refs[this.steps[i].id];
						if (stepRef && stepRef[0] && typeof stepRef[0].generate_description === 'function') {
							// Vérifier si on doit générer uniquement pour les étapes vides
							if (this.generate_only_empty_descriptions) {
								const long_description = stepRef[0].get_long_description();
								if (long_description && long_description.trim() !== '') {
									// L'étape a déjà une description, on la saute
									skipped_count++;
									this.description_progress = i + 1;
									continue;
								}
							}
							
							await stepRef[0].generate_description();
							generated_count++;
							
							// Petite pause pour éviter de surcharger l'API
							await new Promise(resolve => setTimeout(resolve, 500));
						}
					} catch (error) {
						console.error(`Erreur lors de la génération de la description pour l'étape ${i + 1}:`, error);
					}

					this.description_progress = i + 1;
				}

				this.generating_descriptions = false;
				
				let message = `${generated_count} description(s) générée(s) avec succès`;
				if (skipped_count > 0) {
					message += ` (${skipped_count} étape(s) ignorée(s) car déjà remplie(s))`;
				}
				
				this.$notify({
					group: 'info',
					type: 'success',
					title: 'Terminé',
					text: message
				});
			},
			get_step_info(stepId) {
				const stepRef = this.$refs[stepId];
				if (stepRef && stepRef[0]) {
					return {
						comment: stepRef[0].get_comment(),
						long_description: stepRef[0].get_long_description(),
						action_label: stepRef[0].get_action_label(),
						description: stepRef[0].get_description()
					};
				}
				return {
					comment: "",
					long_description: "",
					action_label: "",
					description: ""
				};
			},
			async toggle_custom_prompt_project() {
				if (this.show_custom_prompt_project) {
					this.show_custom_prompt_project = false;
					return;
				}
				if (!this.custom_prompt_project)
					this.custom_prompt_project = `Tu es rédacteur de documentation produit pour un outil de scénarios de traitement de données.

But:
Écrire une description générale de ce que fait le scénario complet (objectif global et résultat attendu), pas une explication détaillée de chaque étape.

Contraintes:
- Interdit: lister toutes les étapes une par une, expliquer le code ligne par ligne.
- Autorisé: décrire le flux global, les transformations principales, l'objectif métier du scénario.`;
				this.show_custom_prompt_project = true;
			},
			reset_custom_prompt_project() {
				this.custom_prompt_project = `Tu es rédacteur de documentation produit pour un outil de scénarios de traitement de données.

But:
Écrire une description générale de ce que fait le scénario complet (objectif global et résultat attendu), pas une explication détaillée de chaque étape.

Contraintes:
- Interdit: lister toutes les étapes une par une, expliquer le code ligne par ligne.
- Autorisé: décrire le flux global, les transformations principales, l'objectif métier du scénario.`;
			},
			async build_project_description_prompt() {
				var request = `Tu es rédacteur de documentation produit pour un outil de scénarios de traitement de données.

But:
Écrire une description générale de ce que fait le scénario complet (objectif global et résultat attendu), pas une explication détaillée de chaque étape.

Contraintes:
- Interdit: lister toutes les étapes une par une, expliquer le code ligne par ligne.
- Autorisé: décrire le flux global, les transformations principales, l'objectif métier du scénario.

`;
				if (this.custom_prompt_project && this.custom_prompt_project.trim())
					request = this.custom_prompt_project.trim() + "\n\n";

				request += "Nom du projet : " + this.name + "\n\n";

				if (this.comment_project) {
					request += "Commentaire du projet : " + this.comment_project + "\n\n";
				}

				if (this.steps.length > 0) {
					request += "Liste des étapes du scénario :\n";

					for (let i = 0; i < this.steps.length; i++) {
						const step = this.steps[i];
						const stepRef = this.$refs[step.id];

						if (stepRef && stepRef[0]) {
							const stepData = await stepRef[0].save();

							request += `\nÉtape ${i + 1}: ${stepData.description || stepData.actionLabel || stepData.action}\n`;

							if (stepData.long_description && stepData.comment) {
								request += `Description: ${stepData.long_description}\n`;
								request += `Commentaire: ${stepData.comment}\n`;
							} else if (stepData.long_description) {
								request += `Description: ${stepData.long_description}\n`;
							} else if (stepData.comment) {
								request += `Commentaire: ${stepData.comment}\n`;
							} else {
								const action = stepData.action;
								const ActionComment = stepRef[0].ActionComment;

								if (ActionComment && ActionComment[action]) {
									request += `Type d'action: ${ActionComment[action]}\n`;
								}

								if (typeof stepRef[0].getRules === 'function') {
									const rules = stepRef[0].getRules();
									if (rules) request += `Conditions: ${rules}\n`;
								}

								if (stepData.data && stepData.data.parameters) {
									request += `Paramètres: ${JSON.stringify(stepData.data.parameters)}\n`;
								}
							}
						}
					}
				}

				return request;
			},
			async generate_project_description() {
				if (!this.name) {
					this.$notify({
						group: 'info',
						type: 'error',
						title: 'Erreur',
						text: 'Le nom du projet est requis'
					});
					return;
				}

				this.generating_project_description = true;

				try {
					const request = await this.build_project_description_prompt();

					var formData = new FormData();
					formData.append("action", "saas_back-openai");
					formData.append("parameters", JSON.stringify({
						"config": "documentation scenario",
						"template": false,
						"content": "request",
						"column_result": "result",
						"column_error": "error",
					}));

					var data = [{request: request }];

					var str_csv = json2csv.parse(data, {
						fields: Object.keys(data[0]),
						fieldNames: Object.keys(data[0]),
					});

					var files = [
						new File([str_csv], "data.csv", {
							type: "text/csv",
						}),
					];

					formData.append(files[0].name, files[0], "data.csv");

					var result = await workers.test(formData);
					var csv_data = await treatments.getFileAlyx(
						result.data.files[0].url,
						false,
						false
					);
					var parsed_data = this.$papa.parse(csv_data, {
						header: true,
					});
					parsed_data = parsed_data.data;

					this.description_project = parsed_data[0].result;

					this.$notify({
						group: 'info',
						type: 'success',
						title: 'Succès',
						text: 'Description du projet générée avec succès'
					});

				} catch (error) {
					console.error('Erreur lors de la génération de la description du projet:', error);
					this.$notify({
						group: 'info',
						type: 'error',
						title: 'Erreur',
						text: 'Erreur lors de la génération de la description'
					});
				} finally {
					this.generating_project_description = false;
				}
			},
			async set_configuration(config)
			{
				this.user_params_config = config;
			},
			/**
			 * Normalise les treatment_params avant de les passer à treatment_params.vue.
			 * - Mappe default_value → default pour les params v2 (format attendu par set())
			 * - Utilise value (valeur courante) comme default si définie, sinon default_value
			 */
			normalize_params_for_form(params) {
				return (params || []).map(p => {
					if (!Array.isArray(p.targets)) return p; // v1 : inchangé
					var default_for_form = p.value !== undefined ? p.value
						: p.default_value !== undefined ? p.default_value : "";
					return Object.assign({}, p, { default: default_for_form });
				});
			},
			async update_columns_result(data)
			{
				this.columns_result = data;
			},
			/**
			 * Crée un nouveau paramètre scénario et l'ajoute à user_params.
			 * Émis par Step.vue via @create_scenario_param.
			 * @param {Object} param - Objet param v2 complet (avec targets)
			 */
			create_scenario_param(param) {
				// Vérification unicité (sécurité côté parent)
				var exists = this.user_params.some(p => p.name === param.name);
				if (exists) return;
				this.user_params = [...this.user_params, param];
				// Mettre à jour le formulaire de test si actif
				if (this.$refs.treatment_params)
					this.$refs.treatment_params.set(this.normalize_params_for_form(this.user_params));
			},
			/**
			 * Ajoute une cible (target) à un paramètre existant.
			 * Émis par Step.vue via @add_param_target.
			 * @param {Object} payload - { param_name, target: { step_uid, jsonpath } }
			 */
			add_param_target(payload) {
				var idx = this.user_params.findIndex(p => p.name === payload.param_name);
				if (idx === -1) return;
				var param = Object.assign({}, this.user_params[idx]);
				var targets = Array.isArray(param.targets) ? [...param.targets] : [];
				// Éviter les doublons sur le même step_uid + jsonpath
				var already = targets.some(t => t.step_uid === payload.target.step_uid && t.jsonpath === payload.target.jsonpath);
				if (!already) targets.push(payload.target);
				param.targets = targets;
				this.$set(this.user_params, idx, param);
			},
			/**
			 * Retire une étape des targets d'un paramètre (dissocier).
			 * Le paramètre reste dans le scénario.
			 * @param {Object} payload - { param_name, step_uid }
			 */
			remove_param_target(payload) {
				var idx = this.user_params.findIndex(p => p.name === payload.param_name);
				if (idx === -1) return;
				var param = Object.assign({}, this.user_params[idx]);
				param.targets = (param.targets || []).filter(t => t.step_uid !== payload.step_uid);
				this.$set(this.user_params, idx, param);
			},
			/**
			 * Ouvre la modal d'édition pour un paramètre depuis le panneau d'une étape.
			 */
			edit_scenario_param(name) {
				if (this.$refs.treatment_params_config)
					this.$refs.treatment_params_config.open_edit_by_name(name);
			},
			open_create_scenario_param(step_uid) {
				if (this.$refs.treatment_params_config)
					this.$refs.treatment_params_config.open_create_with_step(step_uid);
			},
			on_test_values_change(values) {
				this.user_test_values = values;
			},
			async zip()
			{
				scenario.zip()
			},
			async get_initial_files(idx)
			{
				var files = await this.$refs.start_tabulator.get_data_files(false);
				this.$refs.treatment_params.set_initial_files(idx, files);
			},
			update_url_uid() {
				if (!this.uid || !this.$router.currentRoute.path.startsWith("/scenario"))
					return;
				if (this.$route.params.id === this.uid)
					return;
				this.$router.push({ path: '/scenario/' + this.uid }).catch(() => {});
			},
			async save(save_file = true, next_version = true) {
				if (next_version) this.version = this.next_version;

				if (save_file) document.body.style.cursor = "wait";

				//console.log(this.name)

				var tests = clone(this.tests);
				for (var i = 0; i < tests.tests.length; i++) {
					var test = tests.tests[i];
					test.color = "";

					for (var j = 0; j < test.steps.length; j++) {
						if (test.steps[j].test_data)
							delete test.steps[j].test_data;
						if (test.steps[j].diff) delete test.steps[j].diff;
					}
				}

				this.lines_nb = parseInt(this.lines_nb);
				for (var i = 0; i < this.steps_lines.length; i++)
				{
					this.steps_lines[i].step_start = parseInt(this.steps_lines[i].step_start);
					this.steps_lines[i].step_end = parseInt(this.steps_lines[i].step_end);
				}

				if (this.lines_mode === true)
					this.lines = true;
				else
					this.lines = false;

				// Lit les données du tabulator fichier CSV avant sauvegarde
				if (this.init_data.fichier && this.init_data.fichier.active && this.$refs.fichier_init_tabulator)
					this.init_data.fichier.init = this.$refs.fichier_init_tabulator.save();

				// Créer une copie nettoyée de init_data pour la sauvegarde :
				// si fichier.active est false, on vide init pour éviter de bloquer le studio v1
				// (JSONEditor rendrait des centaines de lignes comme champs de formulaire)
				var init_data_save = JSON.parse(JSON.stringify(this.init_data));
				if (init_data_save.fichier && !init_data_save.fichier.active) {
					init_data_save.fichier.init = [];
				}

				var save = {
					studio_v2: true,
					tests: tests,
					project: this.project,
					project_uid: this.project_uid,
					tabulator_import_data:
						this.$refs.start_tabulator.save() || [],
					tabulator_columns_data: this.tabulator_columns_data,
					tabulator_columns_type: this.tabulator_columns_type,
					tabulator_data: this.tabulator_data,
					initial_database: this.$refs.initial_database ? await this.$refs.initial_database.save() : null,
					start_tabulator: this.$refs.start_tabulator.save() || [],
					final_tabulator: this.$refs.final_tabulator.save() || [],
					steps: [],
					collapse: this.collapse,
					listWords: this.listWords,
					initial_method: this.initial_method,
					table: this.table,
					name: this.name,
					version: this.version,
					description: this.description,
					description_project: this.description_project,
					short_description_project: this.short_description_project,
					comment_project: this.comment_project,
					version_test: this.version_test,
					tags: this.tags,
					treatment_actions: this.treatment_actions,
					init_data: init_data_save,
					user_params: this.user_params,
					inDropdownTraitements: this.inDropdownTraitements,
					inDropdownPostTreatments: this.inDropdownPostTreatments,
					render_files: this.render_files,
					browser: this.browser,
					sub_treatment: this.sub_treatment,
					next_treatments: this.next_treatments,
					columns_result: this.columns_result,
					user_params_save: this.user_params_save,
					user_params_save_default: this.user_params_save_default,
					lines: this.lines,
					lines_mode: this.lines_mode,
					lines_nb: this.lines_nb,
					simple_mode: this.simple_mode,
					name_file_init: this.name_file_init || 'data.csv'
				};

				for (var i = 0; i < this.listWords.length; i++) {
					if (this.listWords[i].parameters.db)
						await element.save(
							this.listWords[i].name,
							this.listWords[i].parameters.version,
							this.listWords[i],
							"list"
						);
				}


				if (this.lines_mode === "steps")
				{
					this.steps_lines = [];
				}
				else
					this.steps_lines = false;

				var step_line = null;


				for (var i = 0; i < this.steps.length; i++) 
				{
					var step = this.$refs[this.steps[i].id][0].save();

					if (this.steps_lines && step.lines)
					{
						console.log(" --- ")
						console.log(step_line)
						console.log(i)
						if (step_line == null)
						{
							console.log("null")
							step_line = {
								step_start: i + 1,
								step_end : i + 1
							}
						}
						else
						{
							if (step_line.step_end == i)
							{
								console.log("add")
								step_line.step_end = i + 1;
							}
							else
							{
								console.log("new")
								this.steps_lines.push(step_line);
								step_line = {
									step_start: i + 1,
									step_end : i + 1
								}
							}
						}
					}

					if (
						save_file &&
						step.action == "base de données" &&
						step.data.parameters.token
					)
						delete step.data.parameters.token;
					step.test = this.steps[i].test;

					// * undefined restera undefined
					step.action_choices = this.steps[i].action_choices;
					step.description = this.steps[i].description;
					step.actionGroupDesignation =
						this.steps[i].actionGroupDesignation;
					// console.log("Saving step: " + JSON.stringify(step));
					save.steps.push(step);
				}

				if (this.steps_lines && step_line)
					this.steps_lines.push(step_line);

				save.step_lines = this.steps_lines;

				// Dériver start/end numériques depuis les uid (pour compatibilité worker_dispatch/worker_lines)
				save.tags = (this.tags || []).map(tag => {
					var startIdx = tag.start_uid ? this.steps.findIndex(s => s.uid === tag.start_uid) : -1;
					var endIdx = tag.end_uid ? this.steps.findIndex(s => s.uid === tag.end_uid) : -1;
					return {
						name: tag.name,
						start_uid: tag.start_uid || null,
						end_uid: tag.end_uid || null,
						start: startIdx >= 0 ? startIdx + 1 : 1,
						end: endIdx >= 0 ? endIdx + 1 : this.steps.length,
					};
				});

				if (save_file) {
					document.body.style.cursor = "default";
					this.panel_section = 'scenario';
					utils.saveToFile(
						JSON.stringify(save),
						this.name ? this.name + ".json" : "scenario.json"
					);
				} else return save;
			},
			async load(data, file = false) {
				while (this.ready < 1) {
					await new Promise((resolve) => setTimeout(resolve, 100));
				}
				var self = this;

				self.missing_columns = null;
				self.panel_section = 'scenario';
				self.redraw = true;
				self.tabulator_import_data = data.tabulator_import_data;
				self.tabulator_columns_data = [];

				self.inDropdownTraitements =
					data.inDropdownTraitements === undefined
						? true
						: data.inDropdownTraitements;

				self.inDropdownPostTreatments =
					data.inDropdownPostTreatments === undefined
						? false
						: data.inDropdownPostTreatments;

				var columns = [];
				if (data.tabulator_columns_data) {
					for (
						var i = 0;
						i < data.tabulator_columns_data.length;
						i++
					) {
						if (
							!columns.includes(
								data.tabulator_columns_data[i].colonne
							)
						)
							self.tabulator_columns_data.push(
								data.tabulator_columns_data[i]
							);
						columns.push(data.tabulator_columns_data[i].colonne);
					}
				}
				self.render_files = data.hasOwnProperty("render_files") ? data.render_files : true;
				self.browser = data.hasOwnProperty("browser") ? data.browser : false;
				self.sub_treatment = data.hasOwnProperty("sub_treatment") ? data.sub_treatment : false;
				self.next_treatments = data.hasOwnProperty("next_treatments") ? data.next_treatments : [];
				self.project_uid = file ? this.$uuid.v4() : (data.project_uid || this.$uuid.v4());
				self.tabulator_data = data.tabulator_data;
				self.collapse = false;
				self.collapse_list = false;
				self.listWords = data.listWords || [];
				self.tabulator_columns_type = data.tabulator_columns_type || {};
				self.initial_method = data.initial_method || "fichier";
				self.table = data.table || "";
				self.name_file_init = data.name_file_init || 'data.csv';
				self.name = data.name || "";
				self.version = data.version || "";
				self.description = data.description || "";
				self.description_project = data.description_project || "";
				self.short_description_project = data.short_description_project || "";
				self.comment_project = data.comment_project;
				self.version_test = data.version_test || false;
				self.tags = data.tags;
				self.treatment_actions = data.treatment_actions || [];
				// Reconstruit init_data avec toutes les clés réactives (Vue.set pour compatibilité données anciennes)
				var defaultKeys = {
					fichiers: { active: false, default: false, type: "", at_least_one_file: false },
					fichiers_url: { active: false, default: false, type: "", at_least_one_file: false },
					fichier: { active: false, default: false, init: [] },
					documents: { active: false, default: false, folder: "", extension: "", id_prefix: false },
					"base de données": { active: false, default: false, table: "", params: null },
					"base de données multitables": { active: false, default: false },
					no: { active: false, default: false },
					google_sheet: { active: false, default: false },
					airtable: { active: false, default: false },
				};
				var loaded = data.init_data || {};
				var merged = {};
				for (var k in defaultKeys) {
					merged[k] = loaded[k] ? Object.assign({}, defaultKeys[k], loaded[k]) : defaultKeys[k];
				}
				self.init_data = merged;
				self._sync_init_data_default();
				// Charge les valeurs initiales du fichier CSV dans le tabulator si besoin
				if (self.init_data.fichier.active && self.init_data.fichier.init && self.init_data.fichier.init.length > 0) {
					await self.$nextTick();
					if (self.$refs.fichier_init_tabulator)
						self.$refs.fichier_init_tabulator.set_data(self.init_data.fichier.init);
				}
				self.user_params = (data.user_params || []).map(function(p) {
					if (Array.isArray(p.targets)) return p; // déjà v2
					// Migration v1 -> v2 : step_uid/jsonpath => targets[]
					var target = { step_uid: p.step_uid, jsonpath: p.jsonpath || "" };
					var migrated = Object.assign({}, p, {
						targets: p.step_uid ? [target] : [],
						default_value: p.default_value !== undefined ? p.default_value : (p.default !== undefined ? p.default : ""),
					});
					delete migrated.step_uid;
					delete migrated.jsonpath;
					delete migrated.default;
					return migrated;
				});
				self.columns_result = data.columns_result || [];
				self.user_params_save = data.user_params_save || "";
				self.user_params_save_default = data.user_params_save_default || "";
				self.lines = data.lines || false;
				self.lines_mode = data.lines_mode || false;
				self.steps_lines = data.steps_lines || [];
				self.lines_nb = data.lines_nb || 1;
				self.simple_mode = data.simple_mode === true;

				if (this.$refs.columns_result)
				this.$refs.columns_result.load(self.columns_result);
				if (data.tests) 
					self.tests = data.tests;
				else {
					self.tests = {
						configuration: {
							end: false,
						},
						tests: [],
					};
				}

				//console.log("load")
				var listWords = clone(data.listWords); // * pas besoin de jquery sinon [...data.listWords]
				//console.log(JSON.stringify(data.listWords))

				if (data.project && !self.project) {
					self.project = data.project;
					await self.setProject();
				}

				self.steps = [];
				self.test_checkpoints = [];
				self.view_checkpoint = false;

				//console.log("Steps length: ", data.steps && data.steps.length);
				for (var i = 0; i < (data.steps || []).length; i++) {
					var id = uniqueId("");
					var uid = (data.steps[i].data && data.steps[i].data.uid) ? data.steps[i].data.uid : self.$uuid.v4();
					// Si l'UID est déjà utilisé (étape copiée/collée), en générer un nouveau
					if (self.steps.some(function(s) { return s.uid === uid; })) {
						uid = self.$uuid.v4();
						if (data.steps[i].data) data.steps[i].data.uid = uid;
					}
					var step = {
						test: data.steps[i].test || false,
						description: data.steps[i].description,
						data: {},
						status: "black",
						id,
						uid,
						prev_files: [],
						load_data: data.steps[i],
						source_data: data.steps[i].source_data || "",
						source_data_ids: data.steps[i].source_data_ids || [],
						file_result: data.steps[i].file_result || false,
				};
				self.steps.push(step);
				}

				// Migration source_data (numéros) → source_data_ids (UIDs) pour les vieux scénarios
				for (var mi = 0; mi < self.steps.length; mi++) {
					if (self.steps[mi].source_data && self.steps[mi].source_data_ids.length === 0) {
						var parts = self.steps[mi].source_data.split("|").map(function(p) { return p.trim(); }).filter(Boolean);
						var ids = [];
						for (var pi = 0; pi < parts.length; pi++) {
							if (parts[pi] === "import") { ids.push("import"); continue; }
							var pos = parseInt(parts[pi]) - 1;
							if (pos >= 0 && pos < self.steps.length && self.steps[pos]) {
								ids.push(self.steps[pos].uid);
							}
						}
						self.steps[mi].source_data_ids = ids;
						self.steps[mi].load_data.source_data_ids = ids;
					}
				}

				// Migration des tags anciens format (start/end par numéro) vers le nouveau format (start_uid/end_uid)
				self.tags = (self.tags || []).map(function(tag) {
					if (tag.start_uid !== undefined) return tag; // déjà nouveau format
					var startIdx = (tag.start || 1) - 1;
					var endIdx = (tag.end || 1) - 1;
					return {
						name: tag.name,
						start_uid: (self.steps[startIdx] || {}).uid || null,
						end_uid: (self.steps[endIdx] || {}).uid || null,
					};
				});

				// * empeche les élements step de se régénérer tant qu'on n'a pas fini de charger les steps
				self.stepsLoaded = true;
				self._loading_scenario = true;
				if (self.steps.length === 0) self.stepPickerOpen = true;

				// console.log("Setting next tick: ", new Date());

				await self.$nextTick();
				self._loading_scenario = false;
				// * ces fonctions ne sont pas asynchrones, ça sert à rien d'await
				if (self.$refs.final_tabulator)
					await self.$refs.final_tabulator.load(data.final_tabulator || []);
				if (self.$refs.start_tabulator)
					await self.$refs.start_tabulator.load(
						data.start_tabulator,
						self.table
					);
				if (self.$refs.start_tabulator && self.$refs.start_tabulator.name_file_tabulator !== undefined)
					self.$refs.start_tabulator.name_file_tabulator = self.name_file_init || 'data.csv';
				// Propager name_file_init vers prev_name_file de la première étape
				if (self.steps.length > 0) {
					const firstId = self.steps[0].id;
					if (self.$refs[firstId] && self.$refs[firstId][0])
						self.$refs[firstId][0].prev_name_file = self.name_file_init || 'data.csv';
				}

				for (var i = 0; i < listWords.length; i++) {
					if (self.$refs[listWords[i].id]) {
						await self.$refs[listWords[i].id][0].setData(
							listWords[i].name,
							listWords[i].list,
							listWords[i].parameters
						);
					}
				}

				document.body.style.cursor = "default";
				//console.log("Reset cursor");
				self.panel_section = 'scenario';

				if (self.editor_actions) self.editor_actions.setValue(self.treatment_actions);
				self._sync_init_data_default();

				if (data.tests && data.tests.tests) {
					// Tests tab supprimé — on ne restaure plus les tabulators de test
				}

				// tags est directement réactif, pas besoin de setValue

				if (data.initial_database)
				{
					await self.$nextTick();
					if (self.$refs.initial_database)
						await self.$refs.initial_database.load(data.initial_database)
				}
			},
			async parse_file(file) {
				const reader = new FileReader();
				reader.readAsText(file);
				const result = await new Promise((resolve, reject) => {
					reader.onload = function (event) {
						resolve(reader.result);
					};
				});
				return result;
			},
			async load_file(event) {
				document.body.style.cursor = "wait";
				this.scenario_loading = true;
				var self = this;

				var file = "";
				if (event.dataTransfer) file = event.dataTransfer.files[0];
				else file = event.target.files[0];

				var reader = new FileReader();

				reader.onload = (function (theFile) {
					return async function (e) {
						var data = JSON.parse(e.target.result);

						try {
							await self.load(data, true);
							self.set_state('etape');
						} finally {
							self.scenario_loading = false;
						}
					};
				})(file);

				reader.readAsText(file);
			},
			async save_db(test_scenario = true, next_version = true) {
				//console.log("save scenario db");
				document.body.style.cursor = "wait";

				this.first_test_done = false;

				if (next_version) this.version = this.next_version;

				if (test_scenario) {
					var result = await scenario.load(this.name, this.version);
					if (result.msg != "no scenario") {
						this.save_exist = true;
						document.body.style.cursor = "default";
						return;
					}
				}
				this.save_exist = false;

				var json_data = await this.save(false, next_version);
				var result = await scenario.save(
					this.name,
					this.version,
					this.description,
					this.description_project,
					json_data,
					!this.version_prod,
					this.version_env,
					this.sync_env,
					this.user_params,
					this.tabulator_columns_type,
					{
						tabulator_columns_type: this.tabulator_columns_type,
						columns_result: this.columns_result, 
						user_params_save: this.user_params_save, 
						user_params_save_default: this.user_params_save_default,
						sub_treatment: this.sub_treatment,
						next_treatments: this.next_treatments,
						lines: this.lines,
						steps_lines: this.steps_lines,
						lines_nb: this.lines_nb
					}
				);
				console.log(result)
				document.body.style.cursor = "default";
				if (result.status != 200 || result.errors)
				{
					this.$notify({
						group: "info",
						title: "Erreur de sauvegarde",
						text:
							"Erreur lots de la sauvegarde du scénario " +
							this.name +
							"  (version " +
							this.version +
							") : " + result.errors,
						type: "error",
						duration: -1
					});
				}
				else
				{
					this.$notify({
						group: "info",
						title: "Sauvegarde effectuée",
						text:
							"Le scénario " +
							this.name +
							"  (version " +
							this.version +
							") à été sauvegardé.",
						type: "success",
					});
					if (result.uid) this.uid = result.uid;
					this.update_url_uid();
				}
				this.panel_section = 'scenario';
				this.$bvModal.hide('modal-sauvegarder-' + this.id);

			var scenarios = await scenario.getby_production();

			this.list_name = [];
			for (var i = 0; i < scenarios.length; i++) {
				if (
					!this.list_projects_archive_libelle.includes(
						scenarios[i].libelle
					)
				)
					this.list_name.push({value: scenarios[i].libelle, text: scenarios[i].libelle});
			}				var scenarios = await scenario.getby_libelle(this.name);

				this.list_version = [];
				for (var i = 0; i < scenarios.length; i++) {
					if (i == 0) 
						this.version = scenarios[i].version;
					this.list_version.push({"value": scenarios[i].version, "text" : scenarios[i].dateheure + " - v " + scenarios[i].version});
				}
				this.next_version = scenarios.length + 1;

				if (this.user.env && this.version_env) this.prod_version = "";
				if (!this.user.env && this.version_prod) this.prod_version = "";

				// Refresh project_data in case the save created a new project (e.g. name changed)
				if (result.project_uid)
					await this.setProject(result.project_uid);

				this.sync_env = [];
			},
			// Pré-charge list_version (nom + version) pour un scénario donné, sans passer par le watcher load_name
			// (utilisé quand active_watch est désactivé, ex: chargement direct via URL ou onboarding).
			async _prefetch_list_version(libelle, version) {
				const scenarios = await scenario.getby_libelle(libelle);
				if (scenarios && scenarios.length > 0) {
					this.load_version = version || scenarios[0].version;
					this.list_version = scenarios.map(sc => ({
						description: sc.description,
						value: sc.version,
						text: sc.dateheure + ' - v ' + sc.version
					}));
				}
			},
			async load_db(load_name, load_version) {

				this.onboarding = false;
				this.first_test_done = false;
				this.scenario_loading = true;
				this.$bvModal.hide('modal-charger-' + this.id);

				try {
					if (load_name) this.load_name = load_name;
					if (load_version) this.load_version = load_version;

					document.body.style.cursor = "wait";
					var result = await scenario.load(
						this.load_name,
						this.load_version
					);

					await this.load(result);

					this.next_version = this.list_version.length + 1;
					this.uid = result.uid;

					if (this.active_watch)
						this.update_url_uid();

					this.set_state('etape');

					this.version_env = false;
					this.prod_version = "";
					//console.log(result)
					if (!result.project_uid)
						return;

					await this.setProject(result.project_uid);

					if (this.user.env) {
						if (
							this.uid &&
							this.project_data.details &&
							this.project_data.details.env &&
							this.project_data.details.env[this.user.env] &&
							this.project_data.details.env[this.user.env].scenario ==
								this.uid
						)
							this.version_env = true;
						else if (
							this.uid &&
							(!this.project_data.details.env || !this.project_data.details.env[this.user.env]) &&
							this.project_data.details.scenario == this.uid
						)
							// Pas d'override pour cet env : il suit implicitement la version prod.
							// Si cette version prod est justement celle qu'on édite, l'env est donc
							// déjà "Actif" dessus (pas en "Test").
							this.version_env = true;
						else {
							this.version_env = false;
							if (this.project_data.details && this.project_data.details.env && this.project_data.details.env[this.user.env])
							{
								await this.actual_prod_version(
									this.project_data.details.env[this.user.env].scenario
								);
							}
							else
								await this.actual_prod_version(
									this.project_data.details.scenario
								);
						}
					} else {
						if (
							!this.user.env &&
							this.project_data.details.scenario == this.uid
						)
							this.version_prod = true;
						else {
							this.version_prod = false;
							await this.actual_prod_version(
								this.project_data.details.scenario
							);
						}
					}

					//console.log("end load scenario")
				} finally {
					this.scenario_loading = false;
				}
			},
			async actual_prod_version(uid) {
				var s = await scenario.getby_id(uid);
				if (s && s.length > 0)
				{
					if (s[0].version == this.version)
						this.prod_version = false;
					else
						this.prod_version = s[0].version;
				}
			},
			async archiveProject(item) {
				try {
					await scenario.archive(item.libelle);
					const idx = this.list_projects.findIndex(p => p.uid === item.uid);
					if (idx !== -1) {
						const [removed] = this.list_projects.splice(idx, 1);
						removed.archive = true;
						this.list_projects_archive.push(removed);
					}
					this.$notify({ group: 'info', title: item.libelle + ' archivé', type: 'success' });
				} catch(e) {
					this.$notify({ group: 'info', title: "Erreur lors de l'archivage", type: 'error' });
				}
			},
			async unarchiveProject(item) {
				try {
					await scenario.unarchive(item.uid);
					const idx = this.list_projects_archive.findIndex(p => p.uid === item.uid);
					if (idx !== -1) {
						const [removed] = this.list_projects_archive.splice(idx, 1);
						removed.archive = false;
						this.list_projects.push(removed);
					}
					this.$notify({ group: 'info', title: item.libelle + ' désarchivé', type: 'success' });
				} catch(e) {
					this.$notify({ group: 'info', title: "Erreur lors du désarchivage", type: 'error' });
				}
			},
			async loadLastTreatments() {
				this.archive_loading_treatments = true;
				const allProjects = [
					...this.list_projects,
					...this.list_projects_archive,
				];
				for (const project of allProjects) {
					try {
						const t = await treatments.getAllId(project.uid, 0, 1);
						this.$set(this.archive_last_treatments, project.uid,
							t && t.dateheure_debut ? t.dateheure_debut.replace('T', ' ').substring(0, 16) : null
						);
					} catch(e) {
						this.$set(this.archive_last_treatments, project.uid, null);
					}
				}
				this.archive_loading_treatments = false;
			},
			// Conservé pour compatibilité (utilisé ailleurs dans le composant)
			async archive() {
				if (this.name) await this.archiveProject({ libelle: this.name, uid: null });
			},
			async unarchive() {
				if (this.unarchive_uid) await this.unarchiveProject({ uid: this.unarchive_uid, libelle: this.unarchive_uid });
			},
			async rename() {
				if (this.list_name.includes(this.new_name)) {
					this.$notify({
						group: "info",
						title: this.new_name + "  existe déjà",
						type: "error",
					});

					return;
				}

				await scenario.rename(this.name, this.new_name);
				this.name = this.new_name;
				this.$bvModal.hide('modal-renommer-' + this.id);
				this.save_db(false, false);
			},
			update_name(name) {
				this.name = name;
			},
			set_version(version) {
				this.version = version;
			},
			update_version() {
				if (this.project_data.details)
				{
					if (this.user.env) {
						if (
							this.project_data.details &&
							this.project_data.details.env &&
							this.project_data.details.env[this.user.env]
						)
							this.actual_prod_version(this.project_data.details.env[this.user.env].scenario);
						else
							this.actual_prod_version(this.project_data.details.scenario);
					} else {
						this.actual_prod_version(this.project_data.details.scenario);
					}
				}

				this.next_version = this.version;
			},

			async set_test(idx) {
				var self = this;

				var test = this.tests.tests[idx];

				var data = this.$refs.start_tabulator.get_data();
				test.start_data = clone(data);
				this.$refs["tabulator" + idx][0].load(test.start_data);

				test.steps = [];

				for (var i = 0; i < this.steps.length; i++) {
					if (
						this.steps[i].test ||
						(i + 1 == this.steps.length &&
							this.tests.configuration.end)
					) {
						data = this.$refs[this.steps[i].id][0].get_data();
						if (
							!data ||
							data.length == 0 ||
							Object.keys(data[0]).length == 0
						) {
							data = self.$refs[self.steps[i].id][0].getUrls();
							//console.log("urls")
							//console.log(data)
							if (data.length > 0) {
								data = await treatments.getFileAlyx(
									data[0].url,
									false,
									false
								);
								data = this.$papa.parse(data, { header: true });
								data = data.data;
							}
						}
						test.steps.push({
							step: clone(this.steps[i]),
							data: clone(data),
						});
					}
				}

				self.$nextTick(async function () {
					for (var i = 0; i < test.steps.length; i++) {
						self.$refs[
							"tabulator" + idx + test.steps[i].step.data["uid"]
						][0].load(test.steps[i].data);
					}
				});
			},
			async start_test(idx) {
				var self = this;
				var test = this.tests.tests[idx];
				this.initial_method = "fichier";

				this.test_id = idx;
				test.color = "orange";
				test.nb = 0;

				for (var j = 0; j < test.steps.length; j++) {
					test.steps[j].test_data = [];
					test.steps[j].diff = {
						nb_lines: 0,
					};
					self.$refs[
						"tabulator" +
							idx +
							test.steps[j].step.data["uid"] +
							"result"
					][0].load([]);
				}

				self.$nextTick(async function () {
					if (self.$refs.start_tabulator)
						await self.$refs.start_tabulator.load(test.start_data);
					var step = self.steps[self.steps.length - 1];
					self.$refs[step.id][0].test(true);
				});
			},
			async test_step(idx, step, step_id) {
				//console.log("test_step")
				if (step.test) {
					var self = this;
					var test = this.tests.tests[idx];

					for (var i = 0; i < test.steps.length; i++) {
						if (step.data.uid == test.steps[i].step.data.uid) {
							var data =
								self.$refs[
									self.steps[step_id].id
								][0].get_data();
							//console.log(clone(data))
							if (
								!data ||
								data.length == 0 ||
								Object.keys(data[0]).length == 0
							) {
								data =
									self.$refs[
										self.steps[step_id].id
									][0].getUrls();
								//console.log("urls")
								//console.log(data)
								if (data.length > 0) {
									data = await treatments.getFileAlyx(
										data[0].url,
										false,
										false
									);
									//console.log(data)
									data = this.$papa.parse(data, {
										header: true,
									});
									//console.log(data)
									data = data.data;
									//console.log(data)
								}
							}
							test.steps[i].test_data = clone(data);
							self.$refs[
								"tabulator" + idx + step.data.uid + "result"
							][0].load(test.steps[i].test_data);

							step = test.steps[i];
							step.diff = {
								nb: 0,
								nb_lines: 0,
							};
							data = step.data;
							var data_test = step.test_data;

							//console.log(step)

							step.diff.nb_lines = data.length - data_test.length;
							if (step.diff.nb_lines != 0) step.diff.nb++;

							var keys = [];
							var columns =
								data.length > 0 ? Object.keys(data[0]) : [];
							var columns_test =
								data_test.length > 0
									? Object.keys(data_test[0])
									: [];

							step.diff.columns_less = [];
							step.diff.columns_more = [];

							for (var j = 0; j < columns.length; j++) {
								if (!columns_test.includes(columns[j]))
									step.diff.columns_less.push(columns[j]);
								else keys.push(columns[j]);
							}

							if (step.diff.columns_less.length > 0)
								step.diff.nb++;

							for (var j = 0; j < columns_test.length; j++) {
								if (!columns.includes(columns_test[j]))
									step.diff.columns_more.push(
										columns_test[j]
									);
							}

							if (step.diff.columns_more.length > 0)
								step.diff.nb++;

							var max = data.length;
							if (data_test.length < data.length)
								max = data_test.length;
							step.diff.data = [];
							for (var j = 0; j < max; j++) {
								var obj = {};
								var diff = 0;
								for (var k = 0; k < keys.length; k++) {
									obj[keys[k]] = data[j][keys[k]];
								}
								for (var k = 0; k < keys.length; k++) {
									if (
										data[j][keys[k]] !=
										data_test[j][keys[k]]
									) {
										obj[keys[k]] +=
											" | " + data_test[j][keys[k]];
										diff++;
									}
								}
								if (diff) step.diff.data.push(obj);
							}

							if (step.diff.data.length > 0) step.diff.nb++;

							self.$refs[
								"tabulator" + idx + step.step.data.uid + "diff"
							][0].load(step.diff.data);
							test.nb += step.diff.nb;

							break;
						}
					}
				}
			},
			async test_end(idx) {
				//console.log("test_end")
				var self = this;
				var test = this.tests.tests[idx];

				if (test.nb > 0) 
					test.color = "red";
				else 
					test.color = "green";
			},
			scrollToSection(section) {
				this._scrollSpyPaused = true;
				this.panel_section = section;
				this.$nextTick(() => {
					const container = this.$el.querySelector('.scenario-sections');
					const el = this.$el.querySelector('#section-' + section);
					if (container && el) {
						container.scrollTop = el.offsetTop - container.offsetTop;
					}
					setTimeout(() => { this._scrollSpyPaused = false; }, 400);
				});
			},
			_initScrollSpy() {
				const container = this.$el.querySelector('.scenario-sections');
				if (!container || !('IntersectionObserver' in window)) return;
				if (this._scrollObserver) this._scrollObserver.disconnect();
				this._scrollObserver = new IntersectionObserver((entries) => {
					if (this._scrollSpyPaused || this.panel_section === 'donnees') return;
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							this.panel_section = entry.target.id.replace('section-', '');
						}
					});
				}, { root: container, threshold: 0.25 });
				['scenario', 'colonnes', 'listes', 'donnees_traitement', 'params', 'tags'].forEach(s => {
					const el = this.$el.querySelector('#section-' + s);
					if (el) this._scrollObserver.observe(el);
				});
			},
			set_state(new_state) {
				if (new_state === 'données') {
					if (this.panel_section !== 'donnees') {
						this.prev_panel_section = this.panel_section;
						const c = this.$el.querySelector('.scenario-sections');
						if (c) this.prev_scroll_top = c.scrollTop;
					}
					this.state = 'configuration';
					this.panel_section = 'donnees';
				} else if (new_state === 'configuration') {
					this.state = 'configuration';
					this.panel_section = this.prev_panel_section;
					this.$nextTick(() => {
						const c = this.$el.querySelector('.scenario-sections');
						if (c) c.scrollTop = this.prev_scroll_top;
					});
				} else {
					if (this.panel_section !== 'donnees') {
						this.prev_panel_section = this.panel_section;
						const c = this.$el.querySelector('.scenario-sections');
						if (c) this.prev_scroll_top = c.scrollTop;
					} else {
						this.prev_panel_section = 'scenario';
						this.prev_scroll_top = 0;
					}
					this.state = new_state;
					if (this.panel_section === 'donnees') this.panel_section = 'scenario';
				}
			},
			set_state_test(new_state) {
				this.state_test = new_state;
			},
			async updateTable() {
				this.$refs.start_tabulator.init(this.table);
				if (this.table)
					this.name_file_init = this.table + '.csv';
			},
			async fetch_db_schema() {
				this.db_schema_loading = true;
				try {
					const schema = await database.getSchema();
					console.log('[db_schema] tables:', Object.keys(schema || {}));
					this.db_schema = schema;
				} catch(e) {
					console.warn("fetch_db_schema failed", e);
				} finally {
					this.db_schema_loading = false;
				}
			},
			async setColumnImport() {
				this.$refs.start_tabulator.set_data([
					this.project_data.column_import,
				]);
			},
			async update_final_data(id, data) {
				this.final_tabulator_data = data;
			},
			async make_list(data, column) {
				var self = this;
				var id = uniqueId("");
				this.listWords.push({
					id: "list-" + id,
					name: "liste " + (this.listWords.length + 1),
					list: [],
				});
                
                setTimeout(() => {
                    // console.log("Searching for list ref: ", id);
                    self.$refs["list-" + id][0].importArray(data, column);
					self.$refs["list-" + id][0].setName("liste " + this.listWords.length);
                }, 1);

				// self.$nextTick(function () {
				// 	self.$refs[id][0].importArray(data, column);
				// 	self.$refs[id][0].setName("liste " + this.listWords.length);
				// });
			},
			geProjectUid()
			{
				return this.project_uid;
			},
			getProject(name) {
				for (var i = 0; i < this.list_projects.length; i++) {
					if (
						this.list_projects[i].uid == name ||
						this.list_projects[i].libelle == name
					) {
						return this.list_projects[i];
					}
				}
				return "";
			},
			getFile(files, name) {
				for (var i = 0; i < files.length; i++) {
					if (files[i].name == name) {
						return files[i];
					}
				}
				return null;
			},
			async test_project(
				project,
				formData,
				tags,
				results_files,
				name_file,
				first_csv,
				urls,
				nb_step, 
				step,
				params,
				treatment_params,
				step_uid
			) {
				params = params;
				
				var tag_data = {};
				console.log("test_project")
				console.log('[TEST PROJET] treatment_params reçu:', JSON.stringify(treatment_params));
				console.log('[TEST PROJET] step_uid:', step_uid);
				console.log(project.tags)
				console.log(tags)
				
				if (project.tags && tags) {
					for (var i = 0; i < project.tags.length; i++) {
						if (project.tags[i].tag == tags)
							tag_data = project.tags[i];
					}
				}
				var treatment_data = await treatments.create(
					project.uid,
					null,
					null,
					null,
					[tags],
					tag_data.type_import || "import",
					formData,
					params,
					treatment_params,
					step_uid
				).catch((err) => {
                    console.log("error : " + err);
                    this.$notify({
                        group: "info",
                        title: err.response.data.msg,
                        type: "error",
                    });
                });
				while (
					treatment_data.treatment.resultat != "ok" &&
					treatment_data.treatment.resultat != "ko"
				) {
					await new Promise((resolve) => setTimeout(resolve, 2000));
					treatment_data = await treatments.get(
						treatment_data.treatment.uid
					);
				}
				var all_files = await treatments.getFiles(
					treatment_data.treatment.uid
				);
				if (!all_files || all_files.length == 0) 
					all_files = [];
				all_files.sort((a, b) =>
					a.nom_fichier > b.nom_fichier ? 1 : -1
				);
				var export_type = tag_data.type_export || "export";
				console.log(all_files)
				console.log(tag_data)
				console.log(export_type);
				for (var i = 0; i < all_files.length; i++) {
					if (nb_step <= 1 && this.render_files) {
						if (
							first_csv &&
							all_files[i].type == export_type &&
							all_files[i].nom_fichier.endsWith(".csv") &&
							!step.file_result
						) {
							var csv_data = await treatments.getFile(
								all_files[i].uid,
								all_files[i].nom_fichier,
								false,
								false
							);
							name_file = all_files[i].nom_fichier;
							this.results = this.$papa.parse(csv_data, {
								header: true,
							});
							this.results = this.results.data;
							first_csv = false;
						} else if (all_files[i].type == export_type) {
							urls.push({
								url: all_files[i].url,
								name: all_files[i].nom_fichier,
							});
						}
					} else {
						if (all_files[i].type == export_type)
							urls.push({
								url: all_files[i].url,
								name: all_files[i].nom_fichier,
							});
					}
				}

				return { name_file, first_csv, urls, treatment: treatment_data.treatment };
			},
			async f_stop_test()
			{
				this.stop_test = true;
			},
			// Mode "test en place" du g\u00e9n\u00e9rateur de code (cf steps/fonction.vue,
			// relay\u00e9 par Step.vue) : verrouille/d\u00e9verrouille la navigation entre
			// \u00e9tapes et l'enregistrement du sc\u00e9nario (cf classe .scenario-locked-by-test
			// sur la colonne de navigation, et :disabled sur les boutons Sauvegarder).
			onCodegenTestMode(active)
			{
				this.codegenFocusMode = !!active;
			},
			async test_by_line(
				step,
				id,
				data,
				lots = false)
			{
				console.log("test_by_line");

				console.log(data);

				if (data.action == "fonction" && data.parameters.type != "line")
				{
					this.$notify({
						group: "info",
						title: "Le test ligne à ligne ne marche que pour le mode ligne pour les scripts personnalisés.",
						type: "error",
					});
					return;
				}

				this.stop_test = false;

				step.set_time("start");
				step.set_time("dowload");

				var formData = new FormData();
				var keys = Object.keys(data);
				for (var i = 0; i < keys.length; i++) {
					if (keys[i] != "uid")
						formData.set(
							keys[i],
							typeof data[keys[i]] === "object"
								? JSON.stringify(data[keys[i]])
								: data[keys[i]]
						);
				}

				var prev_id = null;
				var prev_nb = [];
				var prev_ids = [];
				var next_id = null;
				var current_id = null;

				if (step.source_data) {
					prev_nb = step.source_data.split("|");
					for (var i = 0; i < prev_nb.length; i++) {
						if (prev_nb[i] == "import") prev_ids.push("");
						else prev_nb[i] = parseInt(prev_nb[i]);
					}
				}

				for (var i = 0; i < this.steps.length; i++) {
					if (this.steps[i].id == id) {
						current_id = i;
						if (i != 0) 
							prev_id = this.steps[i - 1].id;
						if (i + 1 < this.steps.length)
							next_id = this.steps[i + 1].id;
					}
					if (prev_nb.includes(i + 1))
						prev_ids.push(this.steps[i].id);
				}


				formData.set("sql_rules", step.getRules());
				formData.set("step_uid", step.getUid());

				if (this.$refs.treatment_params) {
					var user_params = this.$refs.treatment_params.get();
					formData.set("treatment_params", JSON.stringify(user_params));
				}

				var lists = {};
				for (var i = 0; i < this.listWords.length; i++) {
					if (!this.listWords[i].parameters.db) {
						var list = [];
						for (
							var j = 0;
							j < this.listWords[i].list.length;
							j++
						) {
							var words = [];
							for (
								var k = 0;
								k < this.listWords[i].list[j].words.length;
								k++
							) {
								words.push(
									this.listWords[i].list[j].words[k].text
								);
							}
							list.push(words);
						}
						lists[this.listWords[i].name] = list;
					}
				}

				formData.set("lists", JSON.stringify(lists));

				var name_file = this.name_file_init || "data.csv";
				if (prev_id !== null) {
					name_file = this.$refs[prev_id][0].get_name_file();
					data = await this.$refs[prev_id][0].get_data();
				} else {
					data = await this.$refs.start_tabulator.get_data();
				}
				var prev_name_file = name_file;
				data = clone(data);

				formData.append("project_uid", this.project_uid);
				formData.append("step_id", current_id + 1);

				if (this.$refs.treatment_params) {
					var treatment_params_config = this.$refs.treatment_params.get_load_name();
					if (treatment_params_config)
						formData.append("treatment_params_config", treatment_params_config);
				}

				var results = [];

				step.set_test_line(0, data.length);
				
				var nb = 1;
				if (lots)
					nb = this.lines_nb;
				for (var i = 0; i < data.length; i += nb)
				{
					var lines = data.slice(i, i + nb)
					var str_csv = json2csv.parse(lines, {
						fields: Object.keys(data[i]),
						fieldNames: Object.keys(data[i]),
					});

					console.log(str_csv)

					var file =
						new File([str_csv], name_file, {
							type: "text/csv",
						})
					;

					console.log(file)

					formData.append(file.name, file);

					this.results = await workers.test(formData, null, null);

					formData.delete(file.name);

					var stop = this.results.data.stop;

					this.logs = this.results.data.error;
					this.script_logs = Array.isArray(this.results.data.logs) ? this.results.data.logs : [];

					console.log('[treatment_params] résultat worker (test_by_line):', this.results.data.treatment_params);
					if (this.results.data.treatment_params && this.$refs.treatment_params) {
						console.log('[treatment_params] appel update_values (test_by_line)');
						this.$refs.treatment_params.update_values(this.results.data.treatment_params);
					}

					var all_files = this.results.data.files;
					if (!all_files || all_files.length == 0) 
						all_files = [];
					all_files.sort((a, b) => (a.name > b.name ? 1 : -1));

					console.log(all_files)
					this.results = [];

					var csv_data = await treatments.getFileAlyx(
						all_files[0].url,
						false,
						false
					);
					name_file = all_files[0].name;
					this.results = this.$papa.parse(csv_data, {
						header: true,
					});
					this.results = this.results.data;

					console.log(this.results);

					results = results.concat(this.results);
					results = tools.standardize_json_all(results);
					this.results = results;

					step.setResults(
						this.results,
						data,
						this.logs,
						[],
						name_file,
						"csv",
						[],
						[],
						this.script_logs,
						0,
						prev_name_file
					);

					step.set_test_line(i + nb, data.length);

					if (this.stop_test)
					{
						break;
					}
				}

				step.set_test_line(0, 0);

				console.log("end")

				//console.log(this.results)

				step.set_time("treatment");
				step.set_time("end");

				step.set_time("upload");

				if (next_id != null) {
					this.steps[current_id + 1].prev_data = this.results;
					this.steps[current_id + 1].prev_files = [];
					this.steps[current_id + 1].prev_urls = [];
				}

				if (stop)
				{
					this.change_status(id, "stop");
				}

				return stop;

			},
			async test(
				step,
				id,
				data,
				before,
				keep_start_data,
				treatment,
				nb_step = 0,
				files_test = null,
				urls_test = null
			) {
				console.log(urls_test)
				// Enregistrer la date du dernier test éditeur (une seule fois par session)
				if (!this.first_test_done && nb_step === 0 && this.project_data && this.project_data.uid) {
					console.log("save date")
					this.first_test_done = true;
					try { await projects.recordTestDate(this.project_data.uid); } catch(e) {
						console.log(e)
					}
				}

				var formData = new FormData();
				var keys = Object.keys(data);
				for (var i = 0; i < keys.length; i++) {
					if (keys[i] != "uid")
						formData.set(
							keys[i],
							typeof data[keys[i]] === "object"
								? JSON.stringify(data[keys[i]])
								: data[keys[i]]
						);
				}

				var prev_id = null;
				var prev_nb = [];
				var prev_ids = [];
				var next_id = null;
				var current_id = null;

				if (step.source_data) {
					prev_nb = step.source_data.split("|");
					for (var i = 0; i < prev_nb.length; i++) {
						if (prev_nb[i] == "import") prev_ids.push("");
						else prev_nb[i] = parseInt(prev_nb[i]);
					}
				}

				for (var i = 0; i < this.steps.length; i++) {
					if (this.steps[i].id == id) {
						current_id = i;
						if (i != 0) 
							prev_id = this.steps[i - 1].id;
						if (i + 1 < this.steps.length)
							next_id = this.steps[i + 1].id;
					}
					if (prev_nb.includes(i + 1))
						prev_ids.push(this.steps[i].id);
				}

				if (before === true) {
					if (prev_id)
					{
						let stop = await this.test(
							this.$refs[prev_id][0],
							this.$refs[prev_id][0].get_id(),
							this.$refs[prev_id][0].get_params_data(),
							true,
							this.$refs[prev_id][0].get_keep_start_data(),
							this.$refs[prev_id][0].get_treatment(),
							nb_step + 1
						);
					if (stop)
						return stop;
					}
				}

				formData.set("sql_rules", step.getRules());
				formData.set("step_uid", step.getUid());

				if (this.$refs.treatment_params) {
					var user_params = this.$refs.treatment_params.get();
					console.log('[TEST] user_params (treatment_params.get()):', JSON.stringify(user_params));
					console.log('[TEST] user_params_test:', this.user_params_test);
					formData.set("treatment_params", JSON.stringify(user_params));
				}

				var lists = {};
				for (var i = 0; i < this.listWords.length; i++) {
					if (!this.listWords[i].parameters.db) {
						var list = [];
						for (
							var j = 0;
							j < this.listWords[i].list.length;
							j++
						) {
							var words = [];
							for (
								var k = 0;
								k < this.listWords[i].list[j].words.length;
								k++
							) {
								words.push(
									this.listWords[i].list[j].words[k].text
								);
							}
							list.push(words);
						}
						lists[this.listWords[i].name] = list;
					}
				}

				formData.set("lists", JSON.stringify(lists));

				this.results = [];

				var results_file = null;
				var results_files = [];
				var name_file = "";
				var type_result = "csv";
				var prev_name_file_input = (prev_id !== null && this.$refs[prev_id] && this.$refs[prev_id][0])
					? this.$refs[prev_id][0].get_name_file()
					: (this.name_file_init || "data.csv");

				var files = [];
				var urls = [];
				if (files_test)
				{
				}
				else if (urls_test)
				{
					urls = urls_test;
				}
				else
				{
					if (prev_ids.length == 0) {
						if (prev_id !== null) {
							urls = this.$refs[prev_id][0].getUrls();
						}
					} else {
						for (var i = 0; i < prev_ids.length; i++) {

							if (prev_ids[i] !== "")
							{
								urls = urls.concat(
									this.$refs[prev_ids[i]][0].getUrls()
								);
							}
						}
					}
				}

				console.log(urls)

				var browser = false;

				if (this.browser && !files_test && this.initial_method != "fichiers" && urls.length == 0 && prev_ids.length == 0 &&
					(data.action == "fonction"
					|| data.action == "sequence"
					|| data.action == "rules"
					|| data.action == "fusionner lignes"
					|| data.action == "split_json"
					|| data.action == "supprimer lignes"
					|| data.action == "nettoyage"
					|| data.action == "blacklist_whitelist"
					|| data.action == "conversion"
					|| data.action == "split"
					|| data.action == "deux points"
					|| data.action == "chercher et classer"
					|| data.action == "chercher et remplacer"
					|| data.action == "mapping colonnes"
					|| data.action == "mapping colonnes - fichier cible"
					|| data.action == "opérations sur colonnes"
					|| data.action == "capitalize"
					|| data.action == "doublons"
					|| data.action == "referentiel"
					|| data.action == "fonctions excel"
					|| data.action == "mapping"))
				{
					var name_file = this.name_file_init || "data.csv";
					if (prev_id !== null) {
						name_file = this.$refs[prev_id][0].get_name_file();
						data = await this.$refs[prev_id][0].get_data();
					} else {
						data = await this.$refs.start_tabulator.get_data();
					}
					data = clone(data);

					var params = await workers.get_params(formData);

					var columns = [];
					if (data.length > 0)
						columns = Object.keys(data[0]);

					if (params.browser == false || data.length * columns.length > 100000)
					{
						formData.append("name", params.name)
						formData.append("body", JSON.stringify(params.body))
					}
					else
					{
						browser = true;
						
						step.set_time("start");
						step.set_time("dowload");
						try
						{
							var result = await workers.execute(params.name, params.body, data);
							this.results = result.data;
							this.logs = result.errors || [];
							this.script_logs = Array.isArray(result.logs) ? result.logs : [];
							step.set_time("treatment");
							step.set_time("end");
							console.log("end treatment csv");
						}
						catch (err)
						{
							this.results = data;
							step.set_time("error");
							console.log(err)
							this.logs = [err];
							this.script_logs = [];
						}

						step.setResults(
							this.results,
							data,
							this.logs,
							[],
							name_file,
							type_result,
							[],
							[],
							this.script_logs,
							0,
							prev_name_file_input
						);

						if (result && result.stop)
						{
							this.change_status(id, "stop");
							return true;
						}
					}

				}

				if (browser == false)
				{

					if (files_test)
					{
						files = files_test;
					}
					else if (urls_test)
					{
					}
					else
					{
						if (prev_ids.length == 0) {
							if (prev_id !== null) {
								files = await this.$refs[prev_id][0].get_data_files();
							} else {
								files = await this.$refs.start_tabulator.get_data_files();
								// Renommer avec name_file_init uniquement pour les modes qui génèrent un
								// fichier "data.csv" générique (edit_tabulator, base de données, ensemble...).
								// En mode "fichiers"/"documents", le composant renvoie les vrais fichiers
								// uploadés : on doit conserver leur nom d'origine.
								if (!['fichiers', 'documents'].includes(this.initial_method)) {
									const wantedName = this.name_file_init || 'data.csv';
									files = files.map(f => f.name !== wantedName ? new File([f], wantedName, { type: f.type }) : f);
								}
							}
						} else {
							for (var i = 0; i < prev_ids.length; i++) {

								if (prev_ids[i] !== "")
								{
									var fs = [];

									fs = await this.$refs[prev_ids[i]][0].get_data_files();
									files = files.concat(fs);
								}
								else {
									files =
										await this.$refs.start_tabulator.get_data_files();
								}
							}
						}
					}

					//console.log(urls)
					//console.log(files)

					var url_files = urls;
					if (urls.length > 0 && !treatment)
						formData.set("url_files", JSON.stringify(urls));

					step.set_time("start");

					var stop = false;

					var urls = [];

					if (!treatment) {

						for (var i = 0; i < files.length; i++) {
							formData.append(files[i].name, files[i]);
						}

						formData.append("project_uid", this.project_uid);
						formData.append("step_id", current_id + 1);

						if (this.$refs.treatment_params) {
							var treatment_params_config = this.$refs.treatment_params.get_load_name();
							if (treatment_params_config)
								formData.append("treatment_params_config", treatment_params_config);
						}

						/*for (var pair of formData.entries()) {
							console.log(pair[0]+ ', ' + pair[1]); 
						}*/

						this.results = await workers.test(formData, step, null);

						console.log('[treatment_params] résultat worker:', this.results.data.treatment_params);

						stop = this.results.data.stop;

						this.logs = this.results.data.error || [];
						this.script_logs = Array.isArray(this.results.data.logs) ? this.results.data.logs : [];

						if (this.results.data.treatment_params && this.$refs.treatment_params) {
							console.log('[treatment_params] appel update_values');
							this.$refs.treatment_params.update_values(this.results.data.treatment_params);
						}

						var all_files = this.results.data.files;
						if (!all_files || all_files.length == 0) all_files = [];
							all_files.sort((a, b) => (a.name > b.name ? 1 : -1));

						//console.log(all_files)
						this.results = [];

						var first_csv = true;
						for (var i = 0; i < all_files.length; i++) {
							if (nb_step <= 1 && this.render_files) {
								if (
									first_csv &&
									all_files[i].name.endsWith(".csv") &&
									!step.file_result
								) {
									var csv_data = await treatments.getFileAlyx(
										all_files[i].url,
										false,
										false
									);
									name_file = all_files[i].name;
									this.results = this.$papa.parse(csv_data, {
										header: true,
									});
									this.results = this.results.data;
									var first_csv = false;
								} else {
									//console.log("other type file");
									urls.push({
										name: all_files[i].name,
										url: all_files[i].url,
									});
								}
							} else {
								urls.push({
									name: all_files[i].name,
									url: all_files[i].url,
								});
							}
						}
					} else {
						console.log(url_files)
						for (var i = 0; i < url_files.length; i++)
						{
							var file = await treatments.getFileAlyx(url_files[i].url, false);
							file = new File([file],url_files[i].name);
							files.push(file);
						}
						// Si aucun fichier depuis l'étape précédente, prendre les fichiers d'import
						if (files.length === 0 && prev_id === null) {
							files = await this.$refs.start_tabulator.get_data_files();
							// Cf. commentaire équivalent plus haut : ne pas renommer les vrais
							// fichiers uploadés (modes "fichiers"/"documents").
							if (!['fichiers', 'documents'].includes(this.initial_method)) {
								const wantedName = this.name_file_init || 'data.csv';
								files = files.map(f => f.name !== wantedName ? new File([f], wantedName, { type: f.type }) : f);
							}
						}
						var urls = [];
						var first_csv = true;
						step.set_time("dowload");
						if (data.parameters.csv) 
						{
							var conditions = [{
								"name": "sql",
								"sql": data.sql_rules
							}];
			                var cond = new Condition();
							var default_project = this.getProject(data.parameters.project);

							var projectsCsv = {
								"": {
										lines: [],
										project: null,
									}
							};
							console.log(files)
							for (var i = 0; i < files.length; i++) {
								if (files[i].name.endsWith(".csv")) {
									var data_csv = await this.parse_file(files[i]);
									data_csv = this.$papa.parse(data_csv, {
										header: true,
									});
									data_csv = data_csv.data;
									console.log(data_csv)
									console.log(conditions)
									for (var j = 0; j < data_csv.length; j++) {
										console.log(data_csv[j]);
										console.log(data.parameters.column_project)
										var project = default_project
										if (data.parameters.column_project && data_csv[j][data.parameters.column_project])
											project = this.getProject(data_csv[j][data.parameters.column_project]);
										var tag = data.parameters.column_tags ? data_csv[j][data.parameters.column_tags] : "";
										if (!conditions || conditions.length == 0 || !cond.test(data_csv[j], conditions))                
										{
											if (!projectsCsv[project.uid + " " + tag]) 
											{
												projectsCsv[project.uid + " " + tag] =
													{
														lines: [],
														project: project,
														tag: tag,
														file: [],
														file_name: [],
													};
											}
											projectsCsv[project.uid + " " + tag].lines.push(data_csv[j]);
										}
										else
											projectsCsv[""].lines.push(data_csv[j]);
									}
								}
							}
							console.log(projectsCsv)
							var keys = Object.keys(projectsCsv);
							console.log(keys)
							for (var i = 0; i < keys.length; i++) {
								if (keys[i])
								{
									console.log("project " + keys[i])
									console.log(projectsCsv[keys[i]].lines)

									var str_csv = json2csv.parse(projectsCsv[keys[i]].lines, {
										fields: Object.keys(projectsCsv[keys[i]].lines.length > 0 ? projectsCsv[keys[i]].lines[0] : []),
										fieldNames: Object.keys(projectsCsv[keys[i]].lines.length > 0 ? projectsCsv[keys[i]].lines[0] : []),
									});

									formData.append("data - " + projectsCsv[keys[i]].project.libelle + ".csv", 
										new File([str_csv], "data - " + projectsCsv[keys[i]].project.libelle + ".csv", {
											type: "text/csv",
										})
									);

									var resp = await this.test_project(
										projectsCsv[keys[i]].project,
										formData,
										data.parameters.tags,
										results_files,
										name_file,
										first_csv,
										urls,
										nb_step,
										step,
										data.parameters || {},
										this.user_params_test ? user_params : [],
										step.getUid()
									);

									console.log("response project")
									console.log(resp)
									if (resp.treatment.resultat == "ko")
									{
										stop = true;
										this.logs = resp.treatment.details.error;
									}

									console.log(clone(resp))
									name_file = resp.name_file;
									first_csv = resp.first_csv
									formData.delete("data - " + projectsCsv[keys[i]].project.libelle + ".csv");
								}
								else if (projectsCsv[keys[i]].lines.length > 0)
								{
									console.log("no project")
									console.log(projectsCsv[keys[i]].lines)
									name_file = "data.csv";
									first_csv = false;
									this.results = projectsCsv[keys[i]].lines;
								}
							}
						}
						else if (data.parameters.column_project) {
							var projectsCsv = {};
							console.log(files)
							for (var i = 0; i < files.length; i++) {
								if (files[i].name.endsWith(".csv")) {
									var data_csv = await this.parse_file(files[i]);
									data_csv = this.$papa.parse(data_csv, {
										header: true,
									});
									data_csv = data_csv.data;
									console.log(data_csv)
									for (var j = 0; j < data_csv.length; j++) {
										var project = this.getProject(data_csv[j][data.parameters.column_project]);
										var tag = data.parameters.column_tags ? data_csv[j][data.parameters.column_tags] : "";
										if (project) 
										{
											if (!projectsCsv[project.uid + " " + tag]) 
											{
												projectsCsv[project.uid + " " + tag] =
													{
														project: project,
														tag: tag,
														file: [],
														file_name: [],
													};
											}
											var file = await treatments.getFileAlyx(data_csv[j][data.parameters.column_url], false, false);
											//console.log(file);
											var file = await treatments.getFileAlyx(data_csv[j][data.parameters.column_url],false);
											file = new File([file], data_csv[j][data.parameters.column_file]);
											//console.log(file)
											if (file && !projectsCsv[project.uid + " " + tag].file_name.includes(data_csv[j][data.parameters.column_file])) 
											{
												projectsCsv[project.uid + " " + tag].file.push(file);
												projectsCsv[project.uid + " " + tag].file_name.push(data_csv[j][data.parameters.column_file]);
											}
										}
									}
								}
							}
							console.log(projectsCsv)
							var keys = Object.keys(projectsCsv);
							for (var i = 0; i < keys.length; i++) {
								for (
									var j = 0;
									j < projectsCsv[keys[i]].file.length;
									j++
								) {
									formData.append(projectsCsv[keys[i]].file_name[j], projectsCsv[keys[i]].file[j]);
								}
								var resp = await this.test_project(
									projectsCsv[keys[i]].project,
									formData,
									data.parameters.tags,
									results_files,
									name_file,
									first_csv,
									urls,
									nb_step,
									step,
									data.parameters || {},
									this.user_params_test ? user_params : [],
									step.getUid()
								);
								
								console.log("response project")
								console.log(resp)

								if (resp.treatment.resultat == "ko")
								{
									stop = true;
									this.logs = resp.treatment.details.error;
								}
								
								name_file = resp.name_file;
								first_csv = resp.first_csv
								for (
									var j = 0;
									j < projects[keys[i]].file.length;
									j++
								) {
									formData.delete(projects[keys[i]].file_name[j]);
								}
							}
						} 
						else {
							for (var i = 0; i < files.length; i++) {
								formData.append(files[i].name, files[i]);
							}

							var project = this.getProject(data.parameters.project);
							//console.log(project)
							var resp = await this.test_project(
								project,
								formData,
								data.parameters.tags,
								results_files,
								name_file,
								first_csv,
								urls,
								nb_step,
								step,
								data.parameters || {},
								this.user_params_test ? user_params : [],
								step.getUid()
							);

							if (resp.treatment.resultat == "ko")
							{
								stop = true;
								this.logs = resp.treatment.details.error;
							}

							console.log("response project")
							console.log(resp)



							name_file = resp.name_file;
							first_csv = resp.first_csv;
							urls = resp.urls;
						}
						step.set_time("treatment");
					}

					step.set_time("upload");

					step.setResults(
						this.results,
						data.file,
						this.logs,
						results_files,
						name_file,
						type_result,
						results_file,
						urls,
						this.script_logs,
						0,
						prev_name_file_input
					);
				}
				if (next_id != null) {
					this.steps[current_id + 1].prev_data = this.results;
					this.steps[current_id + 1].prev_files = results_files;
					this.steps[current_id + 1].prev_urls = urls;
					if (this.$refs[next_id] && this.$refs[next_id][0]) {
						this.$refs[next_id][0].prev_name_file = name_file;
					}
				}

				var columns = [];
				this.missing_columns = null;
				var cible_data = this.$refs.final_tabulator.get_data();

				if (this.results.length > 0 && cible_data.length > 0) {
					this.missing_columns = [];
					columns = [];
					var cible_keys = Object.keys(cible_data[0]);
					var keys = Object.keys(this.results[0]);
					for (var i = 0; i < keys.length; i++) {
						if (cible_keys.includes(keys[i])) columns.push(keys[i]);
					}
					for (var i = 0; i < cible_keys.length; i++) {
						if (!keys.includes(cible_keys[i]))
							this.missing_columns.push(cible_keys[i]);
					}
				}

				if (columns.length == 0) columns = null;

				//this.tabIndex = 1;
				if (keep_start_data)
					this.$refs.intermediate_tabulator.set_data(
						data.file,
						columns
					);
				else
					this.$refs.intermediate_tabulator.set_data(
						this.results,
						columns
					);

				if (this.test_id != null) {
					this.test_step(this.test_id, step, current_id);
				}

				if (nb_step == 0) {
					if (this.test_id != null) {
						this.test_end(this.test_id);
						this.test_id = null;
					}
				}

				if (stop)
				{
					this.change_status(id, "stop");
				}

				return stop;
			},
			async setProject(id) {
				//console.log("setProject")
				this.project_data = {};
				for (var i = 0; i < this.list_projects.length; i++) {
					if (this.list_projects[i].uid == (id ? id : this.project)) {
						//this.project_data = this.list_projects[i];
						this.project_data = await projects.get(id ? id : this.project)
						//console.log("project_data")
						//console.log(this.project_data)
					}
				}
				// If not found in list (e.g. newly created project), fetch directly
				if (!this.project_data.uid && id) {
					this.project_data = await projects.get(id) || {};
				}
			},
			_sync_init_data_default() {
				// Recalcule init_data_default depuis init_data.*.default
				for (var k in this.init_data) {
					if (this.init_data[k] && this.init_data[k].default) {
						this.init_data_default = k;
						return;
					}
				}
				this.init_data_default = null;
			},
			onFichierInitUpdate() {
				if (this.$refs.fichier_init_tabulator)
					this.init_data.fichier.init = this.$refs.fichier_init_tabulator.save();
			},
			onInitDataChange() {
				// init_data est déjà réactif, rien à faire de particulier
			},
			onInitDataDefaultChange(key) {
				// Met default=true seulement pour le type sélectionné
				for (var k in this.init_data) {
					if (this.init_data[k]) this.init_data[k].default = (k === key);
				}
			},
			async initial_database()
			{
				if (this.init_data["base de données"] && this.$refs.initial_database)
				{
					var config = await this.$refs.initial_database.save();
					this.init_data["base de données"].params = config;
				}
			},
			async importFile() {
				var self = this;

				self.tabulator_import_data = this.$refs.start_tabulator.get_data();
				if (this.steps.length > 0) 
				{
					// * on calcule les nouvelles valeurs AVANT de les assigner pour n'écrire
					// * qu'une seule fois sur prev_data/prev_files (sinon le watcher de Step.vue
					// * est déclenché deux fois de suite et setParameters() n'est pas ré-entrant,
					// * ce qui peut réinitialiser la configuration de l'étape)
					var new_prev_files = [];
					var new_prev_data = [];
					if (this.initial_method == "fichiers")
						new_prev_files = await this.$refs.start_tabulator.get_data_files(false);
					else
						new_prev_data = self.tabulator_import_data;
					this.steps[0].prev_files = new_prev_files;
					this.steps[0].prev_data = new_prev_data;
				}
				var fields = [];
				if (self.tabulator_import_data.length > 0)
					fields = Object.keys(self.tabulator_import_data[0]);
				if (self.tabulator_columns_data.length == 1 && self.tabulator_columns_data[0].colonne == "" && fields > 0)
					self.tabulator_columns_data = [];
				// * ici on ne supprime pas les anciens champs s'ils sont plus dans fields
				for (var i = 0; i < fields.length; i++) 
				{
					var index = -1;
					for (var j = 0; j < self.tabulator_columns_data.length; j++) 
					{
						if (self.tabulator_columns_data[j].colonne == fields[i])
							index = j;
					}
					if (index == -1)
						self.tabulator_columns_data.push({colonne: fields[i], type: "texte",});
				}

			},
			addLine: function () {
				this.tabulator_columns_data.push({
					colonne: "",
					type: "texte",
				});
			},
			addList: function () {
				var self = this;

				var id = uniqueId("");
				this.listWords.push({
					id: "list-" + id,
					name: "liste " + (this.listWords.length + 1),
					list: [],
				});
				self.$nextTick(function () {
					self.$refs["list-" + id][0].setName(
						"liste " + this.listWords.length
					);
					self.$refs["list-" + id][0].import_db();
				});
			},
			removeStepDescription(description) {
				for (var i = 0; i < this.steps.length; i++) {
					if (description == this.steps[i].description) {
						if (this.test_checkpoints.length > 0 && this.test_checkpoints[0].after_step_id === this.steps[i].id) {
							const new_after = i > 0 ? this.steps[i - 1].id : null;
							this.$set(this.test_checkpoints, 0, Object.assign({}, this.test_checkpoints[0], { after_step_id: new_after }));
						}
						this.steps.splice(i, 1);
					}
				}
			},
			removeAt(idx) {
				// Si le repère pointait sur cette étape, on le fait pointer sur la précédente (ou null)
				if (this.test_checkpoints.length > 0 && this.test_checkpoints[0].after_step_id === this.steps[idx].id) {
					const new_after = idx > 0 ? this.steps[idx - 1].id : null;
					this.$set(this.test_checkpoints, 0, Object.assign({}, this.test_checkpoints[0], { after_step_id: new_after }));
				}
				this.cleanupCodegenChatsForStep(this.steps[idx]);
				this.steps.splice(idx, 1);
				this.view_step = "";
				this.view_idx = 0;
			},
			removeTestAt(idx) {
				this.tests.tests.splice(idx, 1);
			},
			removeListAt(idx) {
				this.listWords.splice(idx, 1);
			},
			updateList(id, name, list, parameters) {
				for (var i = 0; i < this.listWords.length; i++) {
					if (this.listWords[i].id == id) {
						this.listWords[i].name = name;
						this.listWords[i].list = list;
						this.listWords[i].parameters = parameters;
					}
				}
			},
			async updateStepActionByDescription(description, data, label) {
				for (var i = 0; i < this.steps.length; i++) {
					if (description == this.steps[i].description)
						await this.$refs[this.steps[i].id][0].setAction(data, label);
				}
			},
			updateStepParametersByDescription(description, data, project_id = null) {
				for (var i = 0; i < this.steps.length; i++) {
					if (description == this.steps[i].description)
						this.$refs[this.steps[i].id][0].update_data_parameters(data, project_id);
				}
			},
			async getStepsByDescription(description) {
				var steps = [];
				for (var i = 0; i < this.steps.length; i++) {
					if (this.steps[i].description.includes(description))
					{	
						var step = await this.$refs[this.steps[i].id][0].save_self();
						steps.push(step);
					}
				}
				//console.log(steps);
				return steps;
			},
			existStepByDescription(description) {
				for (var i = 0; i < this.steps.length; i++) {
					if (description == this.steps[i].description)
						return true;
				}
				return false;
			},
			deleteStepByDescription(description, start = false) {
				//console.log("deleteStepByDescription")
				//console.log(description)
				for (var i = 0; i < this.steps.length; i++) {
					if ((!start && description == this.steps[i].description) || (start && this.steps[i].description.startsWith(description)))
					{
						this.cleanupCodegenChatsForStep(this.steps[i]);
						this.steps.splice(i, 1);
						this.view_step = "";
						this.view_idx = 0;
						i--;
					}
				}
			},
			// Nettoyage (best-effort, non bloquant) des conversations IA de génération
			// de code persistées sur S3 pour cette étape (TODO_CODEGEN_CHAT.md section
			// 4.4), avant sa suppression définitive. Ne fait rien si le scénario n'a
			// jamais été enregistré (pas d'uid) : dans ce cas aucun chat n'a pu être
			// persisté sur S3 (cf scenarioCtrl.save / persistCodegenChats).
			cleanupCodegenChatsForStep(stepElement) {
				if (!this.uid || !stepElement || !stepElement.id)
					return;

				try {
					var ref = this.$refs[stepElement.id];
					if (!ref || !ref[0] || !ref[0].save)
						return;

					var saved = ref[0].save();
					var step_uid = saved && saved.data && saved.data.uid;
					var params = saved && saved.data && saved.data.parameters;
					if (!step_uid || !params || typeof params !== "object")
						return;

					var self = this;
					Object.keys(params).forEach(function(key) {
						if (!/_chats$/.test(key) || !Array.isArray(params[key]))
							return;

						params[key].forEach(function(chat) {
							if (chat && chat.uid && chat.url) {
								// Fire-and-forget : on ne bloque jamais la suppression de
								// l'étape pour un échec de nettoyage S3.
								scenario.codegen_chat_delete(self.uid, step_uid, chat.uid).catch(function(err) {
									console.trace(err);
								});
							}
						});
					});
				} catch (err) {
					console.trace(err);
				}
			},
			getStepParametersByDescription(description, data) {
				for (var i = 0; i < this.steps.length; i++) {
					if (description == this.steps[i].description)
						return this.$refs[this.steps[i].id][0].get_params_data().parameters;
				}
			},
			set_init_data(data)
			{
				this.init_data = data;
				this._sync_init_data_default();
			},
			onPickStep: async function (action) {
				this.stepPickerOpen = false;
				await this.addStep({ description: action.label, action: action.value, data: { action: action.value } });
				this.state = "etape";
			},

			// --- Onboarding ---
			async onboarding_check_name() {
				const name = this.onboarding_name.trim();
				if (!name) {
					this.simple_mode = this.onboarding_simple_mode;
					this.onboarding_do_bascule();
					return;
				}
				this.onboarding_checking = true;
				this.onboarding_name_error = '';
				try {
					const existing = await scenario.getby_libelle(name);
					if (existing && existing.length > 0) {
						this.onboarding_name_error = 'Un scénario avec ce nom existe déjà.';
					} else {
						this.simple_mode = this.onboarding_simple_mode;
						this.onboarding_do_bascule();
					}
				} catch (e) {
					this.onboarding_name_error = 'Erreur lors de la vérification.';
				} finally {
					this.onboarding_checking = false;
				}
			},
			onboarding_do_bascule() {
				this.tabulator_import_data = null;
				this.initial_method = null;
				this.$nextTick(() => { this.initial_method = 'fichier'; });
				this.onboarding = false;
				this.onboarding_data_mode = true;
				this.set_state('données');
			},
			async onboarding_confirm() {
				// start_tabulator est déjà le composant studio (section données affichée)
				// Rien à transférer, les données sont déjà au bon endroit
				this.name = this.onboarding_name.trim();
				this.version = '1';
				this.uid = this.$uuid.v4();
				this.onboarding_data_mode = false;
				this.stepPickerOpen = true;
				this.set_state('etape');
			},
			nouveau_scenario() {
				if (this.name || this.steps.length > 0) {
					this.$bvModal.show('modal-nouveau');
				} else {
					this.onboarding = true;
					this.onboarding_screen = 'home';
					this.onboarding_name = '';
					this.onboarding_name_error = '';
				}
			},
			nouveauScenarioConfirm() {
				this.$bvModal.hide('modal-nouveau');
				// Tant que le nouveau scénario n'est pas enregistré, l'uid ne doit pas figurer dans l'url
				if (this.$router.currentRoute.path.startsWith("/scenario/")) {
					this.$router.push({ path: '/scenario' }).catch(() => {});
				}
				// Reset complet du scénario courant
				this.name = '';
				this.version = '';
				this.uid = '';
				this.description = '';
				this.description_project = '';
				this.short_description_project = '';
				this.comment_project = '';
				this.tags = [];
				this.steps = [];
				this.listWords = [];
				this.user_params = [];
				this.columns_result = [];
				this.initial_method = 'fichier';
				this.table = '';
				this.render_files = true;
				this.browser = false;
				this.simple_mode = false;
				this.test_checkpoints = [];
				this.view_checkpoint = false;
				// Reset des données initiales (sinon si initial_method ne change pas, le composant
				// start_tabulator (edit_tabulator, database, ensemble...) n'est pas détruit/recréé
				// par Vue et conserve les données de l'ancien scénario)
				this.tabulator_import_data = null;
				this.name_file_init = 'data.csv';
				this.tabulator_columns_type = {};
				this.tabulator_columns_type_new = "";
				this.tabulator_columns_data = [{ colonne: "", type: "texte" }];
				this.init_data = {
					fichiers:                    { active: true,  default: false, type: "", at_least_one_file: false },
					fichiers_url:                { active: false, default: false, type: "", at_least_one_file: false },
					fichier:                     { active: false, default: false, init: [] },
					documents:                   { active: false, default: false, folder: "", extension: "", id_prefix: false },
					"base de données":           { active: false, default: false, table: "", params: null },
					"base de données multitables": { active: false, default: false },
					no:                          { active: false, default: false },
					google_sheet:                { active: false, default: false },
					airtable:                    { active: false, default: false },
				};
				this.init_data_default = null;
				this.onboarding = true;
				this.onboarding_screen = 'home';
				this.onboarding_name = '';
				this.onboarding_name_error = '';
				this.$nextTick(() => {
					if (this.$refs.start_tabulator && typeof this.$refs.start_tabulator.load === "function")
						this.$refs.start_tabulator.load([]);
				});
			},
			activateComplexMode() {
				this.simple_mode = false;
				this.$bvModal.hide('modal-mode-complet-' + this.id);
				this.save_db(false, false);
			},
			async onboarding_open_load() {
				this.onboarding_load_search = '';
				this.onboarding_load_loading = false;
				this.onboarding_show_archived = false;
				this.onboarding_screen = 'load';
				if (this.list_name.length === 0) {
					this.onboarding_load_loading = true;
					try {
						const scenarios = await scenario.getby_production();
						if (scenarios) {
							for (var i = 0; i < scenarios.length; i++) {
								this.list_name.push({
									text: scenarios[i].libelle,
									value: scenarios[i].libelle,
									description: scenarios[i].description_project,
									uid: scenarios[i].uid
								});
							}
						}
					} finally {
						this.onboarding_load_loading = false;
					}
				}
			},
			async onboarding_load_scenario(s) {
				this.onboarding_load_loading = true;
				try {
				this.onboarding = false;
				await this.$nextTick();

				// Désactiver le watcher pour éviter un double appel load_db
				this.active_watch = false;
				this.load_name = s.value;

				// Pre-fetch la version (ce que ferait le watcher)
				await this._prefetch_list_version(s.value);

				this.active_watch = true;
				await this.load_db();
				this.set_state('etape');
				} finally {
					this.onboarding_load_loading = false;
				}
			},
			// --- Fin Onboarding ---
			addStep: async function (step, first = null, after = null) {
				//console.log(step)

				if (!this.$refs[this.view_step] || !this.$refs[this.view_step][0])
					this.view_step = ""

				if (after)
				{
					this.view_step = "";

					for (var i = 0; i < this.steps.length; i++) {
						for (var j = 0; j < after.length; j++)
						{
							if (this.steps[i].description.includes(after[j]))
							{
								this.view_step = this.steps[i].id;
								this.view_idx = i;
							}
						}
					}
				}

				var prev_urls = [];
				if (this.steps.length === 0) {
					var prev_data = this.$refs.start_tabulator.get_data();
					var prev_files =
						await this.$refs.start_tabulator.get_data_files(false);
				} else if (!this.view_step) {
					var prev_data =
						this.$refs[
							this.steps[this.steps.length - 1].id
						][0].get_data();
					var prev_files = await this.$refs[
						this.steps[this.steps.length - 1].id
					][0].get_data_files(false);
					prev_urls =
						this.$refs[
							this.steps[this.steps.length - 1].id
						][0].getUrls();
				} else {
					//console.log(this.view_step)
					var prev_data = this.$refs[this.view_step][0].get_data();
					var prev_files = await this.$refs[
						this.view_step
					][0].get_data_files(false);
					prev_urls = this.$refs[this.view_step][0].getUrls();
				}
				var id = uniqueId("");
				var uid = this.$uuid.v4();
				if (step) {
					if (after && this.view_step)
					{
						this.steps.splice(this.view_idx + 1, 0, {
							description: step.description,
							data: {},
							status: "black",
							id,
							uid,
							prev_files,
							prev_data,
							prev_urls,
							load_data: step,
						});
						this.view_idx++;
					}
					else if (first)
						this.steps.unshift({
							description: step.description,
							data: {},
							status: "black",
							id,
							uid,
							prev_files,
							prev_data,
							prev_urls,
							load_data: step,
						});
					else if (this.view_step) {
						this.steps.splice(this.view_idx + 1, 0, {
							description: step.description,
							data: {},
							status: "black",
							id,
							uid,
							prev_files,
							prev_data,
							prev_urls,
							load_data: step,
						});
						this.view_idx++;
					} else
						this.steps.push({
							description: step.description,
							data: {},
							status: "black",
							id,
							uid,
							prev_files,
							prev_data,
							prev_urls,
							load_data: step,
						});
				} else if (this.view_step === "") {
					this.steps.push({
						description: "",
						id: id,
						uid,
						prev_files,
						prev_data,
						prev_urls,
						data: { action: "" },
						status: "black",
					});
					this.view_idx = this.steps.length - 1;
				} else {
					this.steps.splice(this.view_idx + 1, 0, {
						description: "",
						id: id,
						uid,
						prev_files,
						prev_data,
						prev_urls,
						data: { action: "" },
						status: "black",
					});
					this.view_idx++;
				}
				this.view_step = id;
			},
			add_test: async function () {
				this.tests.tests.push({
					uid: this.$uuid.v4(),
					name: "test " + (this.tests.tests.length + 1),
					start_data: [],
					steps: [],
				});
			},
			change(id, data, steps, description, source_data="", file_result = false, source_data_ids=[]) {
				for (var i = 0; i < this.steps.length; i++) {
					if (this.steps[i].id == id) {
                        this.steps[i].source_data = source_data;
                        this.steps[i].source_data_ids = source_data_ids;
						// Recalculer source_data (positions) depuis les UIDs
						if (source_data_ids.length > 0) {
							var positions = source_data_ids.map((uid) => {
								if (uid === "import") return "import";
								var idx = this.steps.findIndex(s => s.uid === uid);
								return idx >= 0 ? String(idx + 1) : null;
							}).filter(Boolean);
							this.steps[i].source_data = positions.join("|");
						} else {
							this.steps[i].source_data = "";
						}
						this.steps[i].steps = steps;
						this.steps[i].data = data;
						this.steps[i].file_result = file_result;
						this.steps[i].description =
							description === ""
								? this.steps[i].description
								: description;
						// pour réactivité
						if (!this._loading_scenario) {
							this.$set(this.steps, i, this.steps[i]);
						}
						break;
					}
				}
			},
			async change_user_params()
			{
				// Sauvegarder les valeurs de test courantes avant reconstruction
				var saved_values = {};
				if (this.$refs.treatment_params) {
					var current_params = this.$refs.treatment_params.get();
					for (var cp of current_params) {
						if (cp.name) saved_values[cp.name] = cp.value;
					}
				}

				// Collecter les params v1 (depuis les étapes)
				var v1_params = [];
				for (var i = 0; i < this.steps.length; i++) {
					var step = this.$refs[this.steps[i].id][0];
					v1_params = v1_params.concat(step.get_users_params())
				}

				// Préserver les params v2 (ceux avec `targets` array)
				var v2_params = this.user_params.filter(p => Array.isArray(p.targets));
				var v2_names = new Set(v2_params.map(p => p.name));

				// Fusionner : v2 en premier, puis v1 (sauf si un v2 porte déjà ce nom)
				this.user_params = [
					...v2_params,
					...v1_params.filter(p => !v2_names.has(p.name))
				];

				// Réinitialiser le formulaire de test et restaurer les valeurs saisies
				if (this.$refs.treatment_params) {
					await this.$refs.treatment_params.set(this.normalize_params_for_form(this.user_params));
					if (Object.keys(saved_values).length > 0) {
						this.$refs.treatment_params.update_values(
							Object.entries(saved_values).map(([name, value]) => ({ name, value }))
						);
					}
				}
			},
			change_errors(id, errors) {
				//console.log("change")
				for (var i = 0; i < this.steps.length; i++) {
					if (this.steps[i].id == id) {
						this.steps[i].errors = errors;
						// pour réactivité
						this.$set(this.steps, i, this.steps[i]);
						//console.log(this.steps[i])
						break;
					}
				}
			},
			change_status(id, status) {
				//console.log("status : " + status)
				//console.log("change status")
				for (var i = 0; i < this.steps.length; i++) {
					if (this.steps[i].id == id) {
						//console.log("status")
						if (
							status == "start" ||
							status == "dowload" ||
							status == "treatment"
						) {
							this.steps[i].status = "orange";
						} else if (status == "error") {
							this.steps[i].status = "red";
						} else if (status == "stop") {
							this.steps[i].status = "blue";
						} else {
							this.steps[i].status = "green";
						}
						// pour réactivité
						this.$set(this.steps, i, this.steps[i]);
						//console.log(this.steps[i])
						break;
					}
				}
			},
			onResize() {
				if (this.$refs.div_row)
					this.size =
						this.$refs.div_row.clientWidth -
						this.$refs.div_menu.clientWidth;
			},
			onResizeTest() {
				if (this.$refs.div_row_test)
					this.size_test =
						this.$refs.div_row_test.clientWidth -
						this.$refs.div_menu_test.clientWidth;
			},
		},
		created: async function () {
			if (this.state_prop) this.state = this.state_prop;
			if (this.initial_method_prop)
				this.initial_method = this.initial_method_prop;
			// Si un scénario est directement demandé via l'URL, pas besoin d'onboarding
			if (this.$route && this.$route.params && this.$route.params.id)
				this.onboarding = false;
		},
		beforeDestroy() {
			if (this._scrollObserver) this._scrollObserver.disconnect();
		},
		mounted: async function () {
			this.user = store.state.user;
			if (
				this.config &&
				store.state.user.rules &&
				!store.state.user.rules.scenarios
			) {
				this.$router.push({ name: "profile" });
			}

			// Scroll spy nav
			this.$nextTick(() => { this._initScrollSpy(); });

			// Initialiser Tabulator pour l'éditeur de colonnes
			this.$nextTick(() => {
				if (this.$refs.tabulator_columns) {
					this.tabulator_columns = new Tabulator(this.$refs.tabulator_columns, {
						...this.tabulator_columns_options,
						data: this.tabulator_columns_data,
						layout: "fitData"
					});
				}
			});

			var self = this;

			this.list_projects = await projects.getAll(false, true, null, true);
			this.list_projects_archive_libelle = [];

			this.list_obj_projects_libelle = {};
			this.list_obj_projects_uid = {};
			this.list_projects_libelle = [];

			for (var i = 0; i < this.list_projects.length; i++) {
				if (this.list_projects[i].libelle) {
					this.list_obj_projects_libelle[
						this.list_projects[i].libelle
					] = this.list_projects[i].uid;
					this.list_obj_projects_uid[this.list_projects[i].uid] =
						this.list_projects[i].libelle;
					this.list_projects_libelle.push(
						this.list_projects[i].libelle
					);
				}
				if (this.list_projects[i].archive == true) {
					if (
						this.list_projects[i].details &&
						this.list_projects[i].details.scenario
					) {
						this.list_projects_archive.push(this.list_projects[i]);
						this.list_projects_archive_libelle.push(
							this.list_projects[i].libelle
						);
					}
					this.list_projects.splice(i, 1);
					i--;
				}
			}

			for (var i = 0; i < this.list_projects_archive.length; i++) {
				this.projects_archive_options.push({
					value: this.list_projects_archive[i]["uid"],
					text: this.list_projects_archive[i]["libelle"],
				});
			}

			for (var i = 0; i < this.list_projects.length; i++) {
				this.projects_options.push({
					value: this.list_projects[i]["uid"],
					text: this.list_projects[i]["libelle"],
				});
			}

			for (var i = 0; i < this.list_projects.length; i++) {
				if (
					this.list_projects[i].details &&
					this.list_projects[i].details.column_import
				)
					this.list_projects[i].column_import =
						this.list_projects[i].details.column_import;
				if (this.list_projects[i].details) {
					var _proj_env = this.user && this.user.env;
					var _proj_d = this.list_projects[i].details;
					var _env_d = _proj_env && _proj_d.env && _proj_d.env[_proj_env] ? _proj_d.env[_proj_env] : null;

					// Tags : priorité env > global
					var _proj_tags = (_env_d && Array.isArray(_env_d.tags)) ? _env_d.tags : (_proj_d.tags || null);
					if (_proj_tags) {
						this.list_projects[i].list_tags = [""];
						this.list_projects[i].tags = _proj_tags;
						for (var j = 0; j < _proj_tags.length; j++) {
							if (_proj_tags[j].scenario)
								this.list_projects[i].list_tags.push(_proj_tags[j].tag);
						}
					}

					// treatment_params : priorité env > global
					this.list_projects[i].treatment_params = (_env_d && Array.isArray(_env_d.treatment_params))
						? _env_d.treatment_params
						: (_proj_d.treatment_params || []);
				}
			}

			//console.log("getby_production")

			var scenarios = await scenario.getby_production();

			if (scenarios) {
				for (var i = 0; i < scenarios.length; i++) {
					if (
						!this.list_projects_archive_libelle.includes(
							scenarios[i].libelle
						)
					)
					this.list_name.push({"text": scenarios[i].libelle, "value": scenarios[i].libelle, "description": scenarios[i].description_project, "uid": scenarios[i].uid});
				}
			}
			//console.log(this.list_name)

			this.tabulator_columns_options.rowContextMenu = [
				{
					label: "Supprimer ligne",
					action: function (e, row) {
						row.delete();
						self.tabulator_columns_data =
							self.$refs.tabulator_columns
								.getInstance()
								.getData();
					},
				},
				{
					label: "Duppliquer ligne",
					action: function (e, row) {
						self.tabulator_columns_data.push(
							Object.assign({}, row.getData())
						);
					},
				},
			];

			let response = await users.getSelf(true);
			this.client = response.client;

			this.env_list = [];

			if (this.user.env) {
				this.env_list.push({
					text: "Environnement principal",
					value: "",
				});
			}

			if (this.client.details && this.client.details.env) {
				var keys = Object.keys(this.client.details.env);
				for (var i = 0; i < keys.length; i++) {
					if (keys[i] != this.user.env) {
						this.env_list.push({
							text: this.client.details.env[keys[i]].name,
							value: keys[i],
						});
					}
				}
			}

			var tables = [];
			if (this.client.details && this.client.details.tables)
				tables = this.client.details.tables;

			if (tables && tables.length > 0) {
				for (var i = 0; i < tables.length; i++) {
					this.tables.push(tables[i].name);
				}
			}

			this.fetch_db_schema();

			if (this.$refs.div_row_test) {
				this.ro_test = new ResizeObserver(this.onResizeTest).observe(
					this.$refs.div_row_test
				);
			}
			if (this.$refs.div_row) {
				this.ro = new ResizeObserver(this.onResize).observe(
					this.$refs.div_row
				);
			}

			self.$nextTick(function () {
				if (self.$refs.div_row)
					self.size =
						self.$refs.div_row.clientWidth -
						self.$refs.div_menu.clientWidth;
				if (self.$refs.div_row_test)
					self.size_test =
						self.$refs.div_row_test.clientWidth -
						self.$refs.div_menu_test.clientWidth;
			});

			// Tags : UI native Vue, plus besoin de JSONEditor — ready peut être incrémenté directement
			this.ready++;

			// Boutons d'action supprimé — element sera null, on ne crée pas l'éditeur
			var element = document.getElementById(
				"jsoneditor-action-" + this.id
			);

			if (element) {
				this.editor_actions = new JSONEditor(element, {
					schema: {
						type: "array",
						title: "Boutons d'action",
						items: {
							type: "object",
							title: "Bouton",
							properties: {
								name: {
									title: "Nom du bouton",
									type: "string",
								},
								type: {
									title: "Type de fichier",
									type: "string",
									enum: ["xml"],
								},
								action: {
									title: "Action",
									type: "string",
									enum: ["ftp"],
								},
								folder: {
									type: "string",
									title: "Dossier",
								},
								project: {
									title: "Projet",
									type: "string",
									enum: this.list_projects_libelle,
									default: "",
								},
								project_uid: {
									type: "string",
									options: { hidden: true },
								},
							},
						},
					},
					object_background: "",
					keep_oneof_values: false,
					theme: "bootstrap4",
					iconlib: "fontawesome5",
					prompt_before_delete: false,
				});

				await new Promise((resolve, reject) => {
					self.editor_actions.on("ready", function () {
						self.ready++;
						if (resolve) resolve();
					});
				});

				this.editor_actions.on("change", function () {
					self.treatment_actions = self.editor_actions.getValue();
					for (var i = 0; i < self.treatment_actions.length; i++) {
						if (self.treatment_actions[i].project)
							self.treatment_actions[i].project_uid =
								self.list_obj_projects_libelle[
									self.treatment_actions[i].project
								];
						else self.treatment_actions[i].project_uid = "";
					}
				});
			}

			if (this.$route.params.id)
			{
				var sc = await scenario.getby_id(this.$route.params.id);
				if (sc && sc.length > 0)
				{
					this.active_watch = false;
					this.load_name = sc[0].libelle;
					await this._prefetch_list_version(sc[0].libelle, sc[0].version);
					await this.load_db();
					this.active_watch = true;
					this.set_state('etape');
				}
			}
		},
	};
</script>

<style scoped>
	/* ===== Loader plein écran ===== */
	.studio-loading-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 500;
		background: #ffffff;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.studio-loading-text {
		margin-top: 12px;
		font-size: 1rem;
		color: #495057;
		font-weight: 500;
	}

	/* ===== Repère de test ===== */
	.test-checkpoint-sidebar-item {
		padding: 3px 8px;
		margin: 2px 0;
		cursor: pointer;
		color: #856404;
		font-size: 0.85em;
		font-weight: 600;
		border-left: 3px solid transparent;
		border-radius: 2px;
	}
	.test-checkpoint-sidebar-item:hover,
	.test-checkpoint-sidebar-item.active {
		background: #fffbf0;
		border-left-color: #f0a500;
	}

	/* ===== Onboarding ===== */
	.onboarding-wrapper {
		display: flex;
		justify-content: center;
		align-items: flex-start;
		min-height: 100vh;
		padding: 3rem 2rem;
	}
	.onboarding-wrapper-plain {
		padding: 1rem 0;
		display: flex;
		justify-content: center;
	}
	.onboarding-home {
		width: 100%;
		max-width: 620px;
		margin-top: 10vh;
	}
	.onboarding-create {
		width: 100%;
	}
	.onboarding-data-mode-wrapper {
		padding-top: 1rem;
	}
	.onboarding-data {
		width: 100%;
		max-width: 100%;
	}
	.onboarding-data-content {
		width: 100%;
		max-width: 860px;
		margin-top: 3vh;
	}
	.onboarding-title {
		font-size: 1.8rem;
		font-weight: 700;
		color: #1e293b;
		margin-bottom: 2rem;
		text-align: center;
	}
	.onboarding-subtitle {
		font-size: 1.25rem;
		font-weight: 600;
		color: #1e293b;
		margin-bottom: 1.5rem;
	}
	.onboarding-actions {
		display: flex;
		gap: 1.5rem;
		justify-content: center;
		margin-bottom: 2rem;
	}
	.onboarding-card {
		flex: 1;
		max-width: 220px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 0.75rem;
		padding: 2rem 1.5rem;
		border: 2px solid #e2e8f0;
		border-radius: 12px;
		background: #fff;
		cursor: pointer;
		transition: border-color 0.15s, box-shadow 0.15s, transform 0.1s;
		text-align: center;
	}
	.onboarding-card:hover {
		border-color: #6366f1;
		box-shadow: 0 4px 16px rgba(99,102,241,0.12);
		transform: translateY(-2px);
	}
	.onboarding-card-icon {
		font-size: 2.5rem;
		color: #6366f1;
	}
	.onboarding-card-label {
		font-size: 1rem;
		font-weight: 600;
		color: #374151;
	}
	.onboarding-mode-card {
		flex: 1;
		padding: 0.75rem 1rem;
		border: 2px solid #e2e8f0;
		border-radius: 10px;
		background: #fff;
		cursor: pointer;
		transition: border-color 0.15s, box-shadow 0.15s;
	}
	.onboarding-mode-card:hover {
		border-color: #6366f1;
	}
	.onboarding-mode-card.active {
		border-color: #6366f1;
		background: #eef2ff;
		box-shadow: 0 0 0 3px rgba(99,102,241,0.15);
	}
	.onboarding-skip {
		text-align: center;
		font-size: 0.85rem;
		color: #9ca3af;
	}
	.onboarding-skip a {
		color: #9ca3af;
		text-decoration: underline;
	}
	.onboarding-skip a:hover {
		color: #6366f1;
	}
	.onboarding-back {
		background: none;
		border: none;
		color: #6b7280;
		font-size: 0.875rem;
		cursor: pointer;
		padding: 0;
		margin-bottom: 1.25rem;
	}
	.onboarding-back:hover {
		color: #374151;
	}
	.onboarding-field label {
		font-weight: 600;
		margin-bottom: 0.4rem;
		display: block;
		color: #374151;
	}
	.onboarding-data-tabulator {
		border: 1px solid #e2e8f0;
		border-radius: 8px;
		padding: 1rem;
		background: #fafafa;
		min-height: calc(100vh - 280px);
	}
	.onboarding-data-banner {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 0.5rem;
		margin-bottom: 1rem;
		border-bottom: 1px solid #e2e8f0;
		padding-bottom: 0.75rem;
	}
	.onboarding-load {
		width: 100%;
		max-width: 620px;
		margin-top: 10vh;
		margin-left: auto;
		margin-right: auto;
	}
	.onboarding-load-list {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
		max-height: 60vh;
		overflow-y: auto;
	}
	.onboarding-load-item {
		display: flex;
		align-items: center;
		gap: 0.75rem;
		padding: 0.875rem 1rem;
		border: 1px solid #e2e8f0;
		border-radius: 8px;
		background: #fff;
		cursor: pointer;
		transition: border-color 0.15s, background 0.15s;
	}
	.onboarding-load-item:hover {
		border-color: #6366f1;
		background: #f5f3ff;
	}
	.onboarding-load-item-icon {
		font-size: 1.1rem;
		color: #6366f1;
		flex-shrink: 0;
	}
	.onboarding-load-item-content {
		flex: 1;
		min-width: 0;
	}
	.onboarding-load-item-name {
		font-weight: 600;
		color: #1e293b;
	}
	.onboarding-load-item-desc {
		font-size: 0.8rem;
		color: #6b7280;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.onboarding-load-item-arrow {
		color: #9ca3af;
		flex-shrink: 0;
	}
	.toolbar-btns {
		display: flex;
		gap: 4px;
		flex-wrap: wrap;
		margin-bottom: 2px;
	}
	/* ===== Fin Onboarding ===== */

	/* Mode "test en place" du g\u00e9n\u00e9rateur de code (TODO_CODEGEN_CHAT.md section
	   10) : verrouille la navigation entre \u00e9tapes et l'enregistrement pendant
	   qu'une \u00e9tape teste un code g\u00e9n\u00e9r\u00e9, sans bloquer l'\u00e9tape elle-m\u00eame
	   (rendue \u00e0 c\u00f4t\u00e9, dans div_steps, non concern\u00e9e par cette classe). */
	.scenario-locked-by-test {
		pointer-events: none;
		opacity: 0.5;
		filter: grayscale(60%);
	}

	.margin_projet {
		margin-top: -1rem;
		position: relative;
	}
	.margin_projet.is-loading {
		min-height: 100vh;
	}

	.bouton {
		margin-block-end: 2px;
	}

	/* Supprimer les fonds gris/blanc de Tabulator */
	:deep(.tabulator) {
		background-color: transparent !important;
		border: none !important;
	}

	:deep(.tabulator .tabulator-footer) {
		background-color: transparent !important;
		border: none !important;
	}

	:deep(.tabulator .tabulator-paginator) {
		background-color: transparent !important;
	}

	/* === Panneau unifié: nav gauche + contenu === */
	.section-title {
		font-size: 1rem;
		font-weight: 600;
		color: #374151;
		margin-bottom: 1rem;
		padding-bottom: 0.4rem;
		border-bottom: 2px solid #e9ecef;
	}

	.subsection-title {
		font-size: 0.9rem;
		font-weight: 600;
		color: #6b7280;
		margin-top: 1.25rem;
		margin-bottom: 0.5rem;
	}

	.scenario-actions-bar {
		display: flex;
		gap: 6px;
		flex-wrap: wrap;
		margin-bottom: 16px;
		padding-bottom: 16px;
		border-bottom: 1px solid #e5e7eb;
	}

	.scenario-grid {
		display: grid;
		grid-template-columns: 160px 1fr;
		gap: 16px;
		align-items: start;
		height: calc(100vh - 155px);
	}

	.scenario-grid.onboarding-mode {
		grid-template-columns: 1fr;
		height: auto;
	}

	.scenario-nav {
		display: flex;
		flex-direction: column;
		gap: 2px;
		padding-top: 4px;
		position: sticky;
		top: 0;
		overflow-y: auto;
		max-height: calc(100vh - 155px);
	}

	.scenario-nav-item {
		display: block;
		width: 100%;
		text-align: left;
		padding: 8px 12px;
		border: none;
		border-radius: 6px;
		background: transparent;
		cursor: pointer;
		font-size: 0.875rem;
		color: #374151;
		transition: background 0.15s, color 0.15s;
	}

	.scenario-nav-item:hover {
		background: #f3f4f6;
	}

	.scenario-nav-item.active {
		background: #e8f0fe;
		color: #1a56db;
		font-weight: 500;
	}

	.scenario-sections {
		overflow-y: auto;
		overflow-x: hidden;
		height: 100%;
		padding-right: 4px;
	}

	.scenario-section {
		padding-bottom: 2rem;
		margin-bottom: 0.5rem;
		border-bottom: 1px solid #e9ecef;
	}

	.scenario-section:last-child {
		border-bottom: none;
	}

	.scenario-donnees-content { margin-top: 0; }
</style>
